webpackJsonp([2,0],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, jQuery) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by jv on 04/01/2017.
	 */
	var config = __webpack_require__(671);
	
	var Utils = {};
	var queryParams;
	
	(function (Utils) {
	  var MAX_UID = 1000000;
	
	  Utils.UUID = function () {
	    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0,
	          v = c === "x" ? r : r & 0x3 | 0x8;
	      return v.toString(16);
	    });
	  };
	
	  Utils.generateUIDShort = function () {
	    return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	  };
	
	  Utils.generateElementId = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	    } while (document.getElementById(prefix));
	
	    return prefix;
	  };
	
	  Utils.redirect = function (link) {
	    window.location.href = link;
	  };
	
	  Utils.toType = function (obj) {
	    // https://javascriptweblog.wordpress.com/2011/08/08/fixing-the-javascript-typeof-operator/
	    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
	  };
	
	  // %note: might be better to use https://www.npmjs.com/package/lodash for most of these utility functions
	  Utils.isUndefined = function (obj) {
	    return typeof obj === "undefined";
	  };
	
	  Utils.isDefined = function (obj) {
	    return !Utils.isUndefined(obj);
	  };
	
	  Utils.isNull = function (obj) {
	    return typeof obj === "undefined" || obj === null;
	  };
	
	  Utils.isNotNull = function (obj) {
	    return !Utils.isNull(obj);
	  };
	
	  Utils.isNullOrEmpty = function (str) {
	    return Utils.isNull(str) || str === "";
	  };
	
	  Utils.isString = function (value) {
	    return Utils.isNotNull(value) && typeof value === "string";
	  };
	
	  Utils.isBoolean = function (value) {
	    return value === true || value === false;
	  };
	
	  Utils.isNumber = function (value) {
	    return Utils.isNotNull(value) && !isNaN(value) && typeof value === "number";
	  };
	
	  Utils.isArray = function (obj) {
	    return Utils.isNotNull(obj) && Array.isArray(obj);
	  };
	
	  Utils.isObject = function (obj) {
	    return Utils.isNotNull(obj) && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
	  };
	
	  Utils.isMomentObject = function (obj) {
	    return Utils.isObject(obj) && obj.hasOwnProperty("_isAMomentObject") && obj._isAMomentObject === true;
	  };
	
	  Utils.isFunction = function (obj) {
	    return typeof obj === "function";
	  };
	
	  Utils.isValidEmail = function (email) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	  };
	
	  Utils.stringToInt = function (value) {
	    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
	      return Number(value);
	    }
	
	    return NaN;
	  };
	
	  Utils.stringToBoolean = function (value) {
	    return Utils.isNotNull(value) && (value === "true" || value === true) ? true : false;
	  };
	
	  Utils.parseFloat = function (value) {
	    var parsedValue = parseFloat(value);
	
	    if (Utils.isNumber(parsedValue)) {
	      return parsedValue;
	    }
	
	    return null;
	  };
	
	  Utils.stringifyJSON = function (obj, replacer, space) {
	    return JSON.stringify(obj, replacer, space);
	  };
	
	  Utils.parseJSON = function (str, safe) {
	    if (safe) {
	      try {
	        var objValue = JSON.parse(str);
	        return objValue;
	      } catch (e) {
	        return str;
	      }
	    } else {
	      return JSON.parse(str);
	    }
	  };
	
	  Utils.rgbToHex = function (r, g, b) {
	    if (r > 255 || g > 255 || b > 255) {
	      throw "Invalid color component";
	    }
	
	    var hex = (r << 16 | g << 8 | b).toString(16);
	    return "#" + ("000000" + hex).slice(-6);
	  };
	
	  Utils.hexToRgb = function (hex) {
	    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
	      return r + r + g + g + b + b;
	    });
	
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	    return result ? {
	      r: parseInt(result[1], 16),
	      g: parseInt(result[2], 16),
	      b: parseInt(result[3], 16)
	    } : null;
	  };
	
	  Utils.hexToCmyk = function (hex) {
	    var computedC;
	    var computedM;
	    var computedY;
	    var computedK;
	
	    hex = hex.replace("#", "");
	
	    if (hex.length !== 6) {
	      return null;
	    }
	    if (/[0-9a-f]{6}/i.test(hex) !== true) {
	      return null;
	    }
	
	    var r = parseInt(hex.substring(0, 2), 16);
	    var g = parseInt(hex.substring(2, 4), 16);
	    var b = parseInt(hex.substring(4, 6), 16);
	
	    // BLACK
	    if (r === 0 && g === 0 && b === 0) {
	      return {
	        c: 0,
	        m: 0,
	        y: 0,
	        k: 1
	      };
	    }
	
	    computedC = 1 - r / 255;
	    computedM = 1 - g / 255;
	    computedY = 1 - b / 255;
	
	    var minCMY = Math.min(computedC, Math.min(computedM, computedY));
	
	    computedC = (computedC - minCMY) / (1 - minCMY);
	    computedM = (computedM - minCMY) / (1 - minCMY);
	    computedY = (computedY - minCMY) / (1 - minCMY);
	    computedK = minCMY;
	
	    return {
	      c: computedC,
	      m: computedM,
	      y: computedY,
	      k: computedK
	    };
	  };
	
	  Utils.roundNumber = function (number, decimals) {
	    if (Utils.isNumber(number)) {
	      var rounder = Math.pow(10, decimals);
	      return Math.round(number * rounder) / rounder;
	    }
	
	    return NaN;
	  };
	
	  Utils.format = function (format) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return format.replace(/{(\d+)}/g, function (match, number) {
	      return Utils.isDefined(args[number]) ? args[number] : match;
	    });
	  };
	
	  Utils.formatMoney = function (value, currency) {
	    if (currency.beforePrice) {
	      return currency.symbol + " " + Utils.roundNumber(value, 2).toFixed(2);
	    }
	
	    return Utils.roundNumber(value, 2) + " " + currency.symbol;
	  };
	
	  Utils.formatTime = function (s, format) {
	    var hr = Math.floor(s / 3600);
	    var min = Math.floor((s - hr * 3600) / 60);
	    var sec = Math.floor(s - hr * 3600 - min * 60);
	
	    if (hr < 10) {
	      hr = "0" + hr;
	    }
	    if (min < 10) {
	      min = "0" + min;
	    }
	    if (sec < 10) {
	      sec = "0" + sec;
	    }
	
	    if (Utils.isNotNull(format)) {
	      var formattedTime = format.replace("hh", hr);
	      formattedTime = formattedTime.replace("h", hr * 1 + ""); // check for single hour formatting
	      formattedTime = formattedTime.replace("mm", min);
	      formattedTime = formattedTime.replace("m", min * 1 + ""); // check for single minute formatting
	      formattedTime = formattedTime.replace("ss", sec);
	      formattedTime = formattedTime.replace("s", sec * 1 + ""); // check for single second formatting
	      return formattedTime;
	    } else {
	      return hr + ":" + min + ":" + sec;
	    }
	  };
	
	  Utils.getRandomIntInclusive = function (min, max) {
	    min = Math.ceil(min);
	    max = Math.floor(max);
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  };
	
	  Utils.getContrastYIQ = function (hexColor) {
	    hexColor = hexColor.replace("#", "");
	
	    var r = parseInt(hexColor.substr(0, 2), 16);
	    var g = parseInt(hexColor.substr(2, 2), 16);
	    var b = parseInt(hexColor.substr(4, 2), 16);
	    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
	
	    return yiq;
	  };
	
	  Utils.getContrastColor = function (color, options) {
	    options = Utils.isNotNull(options) ? options : {};
	
	    var yiqColor = Utils.getContrastYIQ(color);
	
	    var threshold = Utils.isNumber(options.threshold) ? options.threshold : 256 / 2;
	    var belowThresholdColor = Utils.isNotNull(options.belowThresholdColor) ? options.belowThresholdColor : "#ffffff";
	    var aboveThresholdColor = Utils.isNotNull(options.aboveThresholdColor) ? options.aboveThresholdColor : "#000000";
	
	    return yiqColor < threshold ? belowThresholdColor : aboveThresholdColor;
	  };
	
	  Utils.invertColor = function (hexColor) {
	    hexColor = hexColor.replace("#", ""); // remove #
	    hexColor = parseInt(hexColor, 16); // convert to integer
	    hexColor = 0xFFFFFF ^ hexColor; // invert three bytes
	    hexColor = hexColor.toString(16); // convert to hex
	    hexColor = ("000000" + hexColor).slice(-6); // pad with leading zeros
	    hexColor = "#" + hexColor; // prepend #
	
	    return hexColor;
	  };
	
	  Utils.resetFormElement = function (el) {
	    $(el).wrap("<form></form>").closest("form").get(0).reset();
	    $(el).unwrap();
	  };
	
	  Utils.findObjectDeep = function (obj, path, createMissing) {
	    path = path.split(".");
	    for (var i = 0; i < path.length; i++) {
	      if (Utils.isUndefined(obj[path[i]]) && createMissing) {
	        obj[path[i]] = {};
	      }
	
	      obj = obj[path[i]];
	    };
	
	    return obj;
	  };
	
	  Utils.getServiceUrl = function (path) {
	    return config.serviceBaseURL + path;
	  };
	
	  Utils.getStatusOrder = function (status) {
	    switch (status) {
	      case "error":
	        return 1;
	      case "warning":
	        return 2;
	      case "info":
	        return 3;
	      case "complete":
	      default:
	        return 4;
	    }
	  };
	
	  Utils.luhnCheck = function (str) {
	    return str.split("").reduceRight(function (prev, curr, idx) {
	      if ((idx + 1) % 2 !== 0) {
	        curr = (curr * 2).toString().split("").reduce(function (p, c) {
	          return +p + +c;
	        });
	      }
	      return +prev + +curr;
	    }) % 10 === 0;
	  };
	
	  Utils.getQueryParam = function (name) {
	    return queryParams[name];
	  };
	
	  Utils.getUrlPath = function () {
	    return window.location.pathname;
	  };
	
	  Utils.getPathSection = function (index) {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    for (var i = 0; i < pathSections.length; i++) {
	      var pathSection = pathSections[i];
	
	      if (Utils.isNullOrEmpty(pathSection)) {
	        index++;
	        continue;
	      }
	
	      if (i + 1 === index) {
	        return pathSection;
	      }
	    }
	
	    return null;
	  };
	
	  Utils.btoa = function (stringToEncode) {
	    return Utils.isNotNull(stringToEncode) ? window.btoa(encodeURIComponent(stringToEncode)) : null;
	  };
	
	  Utils.atob = function (stringToDecode) {
	    return Utils.isNotNull(stringToDecode) ? decodeURIComponent(window.atob(stringToDecode)) : null;
	  };
	
	  Utils.debounce = function (func, wait, immediate) {
	    var timeout;
	    return function () {
	      var context = this,
	          args = arguments;
	      var later = function later() {
	        timeout = null;
	        if (!immediate) func.apply(context, args);
	      };
	
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) func.apply(context, args);
	    };
	  };
	
	  Utils.ImageSVGToSVG = function () {
	    jQuery("img.svg").each(function () {
	      var $img = jQuery(this);
	      var imgID = $img.attr("id");
	      var imgClass = $img.attr("class");
	      var imgURL = $img.attr("src");
	
	      jQuery.get(imgURL, function (data) {
	        // Get the SVG tag, ignore the rest
	        var $svg = jQuery(data).find("svg");
	
	        // Add replaced image's ID to the new SVG
	        if (typeof imgID !== "undefined") {
	          $svg = $svg.attr("id", imgID);
	        }
	        // Add replaced image's classes to the new SVG
	        if (typeof imgClass !== "undefined") {
	          $svg = $svg.attr("class", imgClass + " replaced-svg");
	        }
	
	        // Remove any invalid XML tags as per http://validator.w3.org
	        $svg = $svg.removeAttr("xmlns:a");
	
	        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
	        if (!$svg.attr("viewBox") && $svg.attr("height") && $svg.attr("width")) {
	          $svg.attr("viewBox", "0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
	        }
	
	        // Replace image with new SVG
	        $img.replaceWith($svg);
	      }, "xml");
	    });
	  };
	})(Utils);
	
	// Load query parameters once
	(window.onpopstate = function () {
	  var match,
	      pl = /\+/g,
	      // Regex for replacing addition symbol with a space
	  search = /([^&=]+)=?([^&]*)/g,
	      decode = function decode(s) {
	    return decodeURIComponent(s.replace(pl, " "));
	  },
	      query = window.location.search.substring(1);
	
	  queryParams = {};
	  while (match = search.exec(query)) {
	    var name = decode(match[1]);
	    var value = decode(match[2]);
	
	    if (queryParams.hasOwnProperty(name)) {
	      if (!Utils.isArray(queryParams[name])) {
	        // Make it an array
	        queryParams[name] = [queryParams[name]];
	      }
	
	      queryParams[name].push(value);
	    } else {
	      queryParams[name] = value;
	    }
	  }
	})();
	
	module.exports = Utils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(14)))

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * User: jv
	 * Date: 12/05/16
	 * Time: 12:56
	 */
	var utils = __webpack_require__(25);
	var log = __webpack_require__(375)();
	var CONSTANTS = __webpack_require__(672);
	var localeReq = __webpack_require__(37);
	
	var LanguageManager = {};
	
	(function (LanguageManager) {
	  var locale = null;
	  var localeMap = null;
	
	  LanguageManager.init = function () {
	    locale = getLocaleFromCookie();
	
	    if (locale === null) {
	      locale = localStorage.getItem("locale");
	    }
	
	    var tmpLocale = utils.getQueryParam("locale");
	    if (!utils.isNullOrEmpty(tmpLocale)) {
	      locale = tmpLocale;
	      localStorage.setItem("locale", locale);
	    }
	
	    if (utils.isNullOrEmpty(locale) || !localeExists(locale)) {
	      locale = CONSTANTS.DEFAULT_LOCALE;
	    }
	
	    $("html").addClass(locale);
	
	    _init();
	  };
	
	  function _init() {
	    getLocaleMap();
	    applyLocale();
	    $(".page-wrapper").show();
	
	    if (utils.isFunction(LanguageManager.onInit)) {
	      LanguageManager.onInit();
	    }
	
	    if (utils.isFunction(LanguageManager.onInitGlobal)) {
	      LanguageManager.onInitGlobal();
	    }
	  }
	
	  LanguageManager.onInit = null;
	
	  LanguageManager.onInitGlobal = null;
	
	  LanguageManager.changeLocale = function (newLocale) {
	    if (localeExists(newLocale)) {
	      $("html").removeClass(locale).addClass(newLocale);
	      locale = newLocale;
	      localStorage.setItem("locale", locale);
	      LanguageManager.localize();
	    } else {
	      throw "Locale does not exist";
	    }
	  };
	
	  LanguageManager.getCurrentLocale = function () {
	    return locale;
	  };
	
	  LanguageManager.localize = function () {
	    if (!localeMapIsDefined() || locale !== localeMap.locale) {
	      getLocaleMap();
	      applyLocale();
	    } else {
	      applyLocale();
	    }
	  };
	
	  function getLocaleMap() {
	    try {
	      log.info("Trying to fetch locale '%s'", locale);
	
	      var localeRequire = "./" + locale + ".json";
	
	      log.info("'%s' is in %o ? %s", localeRequire, localeReq.keys(), $.inArray(localeRequire, localeReq.keys()) !== -1);
	
	      if ($.inArray(localeRequire, localeReq.keys()) !== -1) {
	        var tmpLocaleMap = localeReq(localeRequire);
	
	        log.info("Successfully fetched locale map for locale [%s]: %o", locale, tmpLocaleMap);
	
	        localeMap = tmpLocaleMap;
	      } else if (locale !== "nl-BE" && $.inArray("./nl-BE.json", localeReq.keys()) !== -1) {
	        $("html").removeClass(locale).addClass("nl-BE");
	        locale = "nl-BE";
	        localStorage.setItem("locale", locale);
	        getLocaleMap(callback);
	      } else {
	        log.error("Couldn't find locale [%s] in known locale list: %o", locale, localeReq.keys());
	        alert("Localisation could not be loaded, contact your site administrator.");
	      }
	    } catch (e) {
	      console.error(e);
	    }
	  }
	
	  function localeExists(pLocale) {
	    var localeRequire = "./" + pLocale + ".json";
	
	    return $.inArray(localeRequire, localeReq.keys()) !== -1;
	  }
	
	  LanguageManager.applyLocale = function (selector) {
	    if (localeMapIsDefined() && locale === localeMap.locale) {
	      // Add back to include the selector itself
	      applyLocale($(selector).find("[data-localize]").addBack(selector).filter("[data-localize]"));
	    }
	  };
	
	  function applyLocale($element) {
	    $element = utils.isNotNull($element) ? $element : $("[data-localize]");
	
	    $element.each(function () {
	      var element = $(this);
	      var key = $(this).data("localize");
	
	      if (localeMapIsDefined() && localeMap.localization.hasOwnProperty(key)) {
	        changeTextOrPlaceholder(element, localeMap.localization[key]);
	      } else {
	        changeTextOrPlaceholder(element, key);
	      }
	    });
	
	    $element = $("[data-locale]").hide();
	
	    $element.each(function () {
	
	      var element = $(this);
	      var key = $(this).data("locale");
	
	      if (key === locale) {
	        element.show();
	      }
	    });
	  }
	
	  function changeTextOrPlaceholder(element, text) {
	    if (element.is("input") || element.is("textarea")) {
	      //element.attr("placeholder", text.toLowerCase());
	      element.attr("placeholder", text);
	    } else if (element.is("img")) {
	      element.attr("src", text);
	    } else {
	      replaceNodeText(element, text);
	    }
	  }
	
	  function replaceNodeText(element, text) {
	    element.html(text);
	  }
	
	  LanguageManager.getValueForKey = function (key) {
	    if (localeMapIsDefined() && localeMap.localization.hasOwnProperty(key)) {
	      return localeMap.localization[key];
	    } else {
	      return key;
	    }
	  };
	
	  function localeMapIsDefined() {
	    return utils.isObject(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
	  }
	
	  function getLocaleFromCookie() {
	    var locale = readFromCookie("locale");
	
	    if (locale !== null) {
	      locale = locale.replace("_", "-");
	    }
	
	    return locale;
	  }
	
	  function readFromCookie(name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(";");
	
	    for (var i = 0; i < ca.length; i++) {
	      var c = ca[i];
	      while (c.charAt(0) === " ") {
	        c = c.substring(1, c.length);
	      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	    }
	
	    return null;
	  }
	})(LanguageManager);
	
	module.exports = LanguageManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 10/03/2017.
	 */
	// Styles
	__webpack_require__(922);
	__webpack_require__(908);
	__webpack_require__(907);
	__webpack_require__(923);
	__webpack_require__(909);
	
	// js
	__webpack_require__(697);
	__webpack_require__(705);
	__webpack_require__(699);
	// These libs aren't nice and put themselves in window instead of being able to be required into a variable
	// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
	// https://webpack.github.io/docs/shimming-modules.html
	__webpack_require__(1627); // Is used to check if browser is outdated
	__webpack_require__(1626); // requires the cookieconsent library like it was a script tag in the html
	__webpack_require__(1625);
	
	var LanguageManager = __webpack_require__(38);
	var utils = __webpack_require__(25);
	var log = __webpack_require__(375)();
	var Dialog = __webpack_require__(698);
	
	var slick = __webpack_require__(1628);
	
	var Shared = {};
	
	(function (Shared) {
	  Shared.init = function () {
	    if (Shared.isOutdated()) {
	      log.info("Browser is outdated, redirecting to /outdated");
	      utils.redirect("/outdated");
	    }
	
	    setUpFragmentImages();
	
	    LanguageManager.init();
	
	    setUpLocalizedResources();
	  };
	
	  LanguageManager.onInitGlobal = function () {
	    try {
	      cookieconsent.initialise({
	        palette: {
	          popup: {
	            background: "#946331",
	            text: "#fff9eb"
	          },
	          button: {
	            background: "#fff9eb",
	            text: "#946331"
	          }
	        },
	        theme: "classic",
	        content: {
	          message: LanguageManager.getValueForKey("cookies.message"),
	          dismiss: LanguageManager.getValueForKey("cookies.button.text"),
	          link: LanguageManager.getValueForKey("cookies.link.text"),
	          href: LanguageManager.getValueForKey("cookies.link")
	        }
	      });
	    } catch (e) {
	      console.error(e);
	    }
	
	    $(".language-selector a").removeClass("active");
	    $(".language-selector a[data-locale-active='" + LanguageManager.getCurrentLocale() + "']").addClass("active");
	  };
	
	  Shared.isOutdated = function () {
	    return !Modernizr.filereader;
	  };
	
	  function setUpFragmentImages() {
	    var headerNLLogo = __webpack_require__(1659);
	    var headerFRLogo = __webpack_require__(1658);
	    var footerLogo = __webpack_require__(1660);
	
	    $(".navbar-brand.mx-auto").append("<img src='" + headerNLLogo + "' data-locale='nl-BE'/>");
	    $(".navbar-brand.mx-auto").append("<img src='" + headerFRLogo + "' data-locale='fr-BE'/>");
	
	    $(".footer-logo").append("<a href='https://www.delhaize.be' target='_blank'><img src='" + footerLogo + "'/></a>");
	  }
	
	  // a tag is added in localization - this needs to be called after LanguageManager.init()
	  function setUpLocalizedResources() {
	    var eulaNL = __webpack_require__(937);
	    var eulaFR = __webpack_require__(924);
	
	    var rulesNl = __webpack_require__(936);
	    var rulesFr = __webpack_require__(935);
	
	    $("#eula_nl-BE a").attr("href", eulaNL);
	    $("#eula_fr-BE a").attr("href", eulaFR);
	
	    $("#competition-rules_nl-BE a").attr("href", rulesNl);
	    $("#competition-rules_fr-BE a").attr("href", rulesFr);
	  }
	
	  Shared.Dialog = Dialog;
	})(Shared);
	
	(function () {
	  "use strict";
	
	  if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
	    var msViewportStyle = document.createElement("style");
	    msViewportStyle.appendChild(document.createTextNode("@-ms-viewport{width:auto!important}"));
	    document.head.appendChild(msViewportStyle);
	  }
	})();
	
	module.exports = Shared;
	
	/* add referrer to language selector*/
	$(".language-selector-wrapper a").each(function () {
	  var link = $(this); // %TODO: referer meteen zetten op fr of nl domein
	  link.attr("href", link.attr("href") + "&referer=" + window.location.pathname.substring(6));
	});
	
	$(".language-selector-menu li a").each(function () {
	  var link = $(this); // %TODO: referer meteen zetten op fr of nl domein
	  link.attr("href", link.attr("href") + "&referer=" + window.location.pathname.substring(6));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by jv on 30/05/2018.
	 */
	var ATLAS_KEY = "carrot-game-atlas";
	
	exports.default = {
	  DEBUG: false,
	
	  ATLAS_KEY: ATLAS_KEY,
	
	  OBSTACLES: ["obstacles/obstacle_bucket.png", "obstacles/obstacle_fence.png", "obstacles/obstacle_hay-bale.png", "obstacles/obstacle_manger.png", "obstacles/obstacle_milk-jug.png", "obstacles/obstacle_mudpool.png", "obstacles/obstacle_watering-can.png"],
	  POWER_UPS: [
	  // { key: ATLAS_KEY, frame: "power-ups/powerup_bounce-ball.png", type: "springball", duration: 15 * 1000 },
	  { key: ATLAS_KEY, frame: "power-ups/powerup_magnet.png", activeTexture: { key: ATLAS_KEY, frame: "power-ups/powerup_magnet-active.png", offset: { x: 0, y: 0 } }, type: "magnet", duration: 18 * 1000 }, { key: ATLAS_KEY, frame: "power-ups/powerup_rocket-cake.png", type: "rocket-cake", duration: 15 * 1000 }, { key: ATLAS_KEY, frame: "power-ups/powerup_shield.png", activeTexture: { key: ATLAS_KEY, frame: "power-ups/powerup_shield-active.png", offset: { x: 75, y: 30 } }, type: "shield", duration: 18 * 1000 }]
	};

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by jv on 30/05/2018.
	 */
	var ATLAS_KEY = "chicken-game-atlas";
	
	exports.default = {
	  DEBUG: false,
	
	  ATLAS_KEY: ATLAS_KEY,
	
	  DROP_MODES: {
	    ANYWHERE: "anywhere",
	    ZONE_ONLY: "zone-only"
	  },
	
	  CHICK_HATCH_POSITIONS: ["left", "bottom", "right"],
	  CHICK_RUN_DIRECTIONS: ["n", "ne", "e", "se", "s", "sw", "w", "nw"]
	};

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var utils = __webpack_require__(25);
	var LanguageManager = __webpack_require__(38);
	
	var figurinesData = __webpack_require__(983);
	var figurinesImages = __webpack_require__(221);
	
	module.exports = function () {
	  function FigurineCarousel(options) {
	    _classCallCheck(this, FigurineCarousel);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.element = options.element;
	    this.startAt = utils.isNotNull(options.startAt) ? options.startAt.replace(/#/g, "") : "karla";
	    this.clickCallBack = options.clickCallBack;
	    this.centered = utils.isNotNull(options.centered) && options.centered !== undefined ? options.centered : false;
	    this.figurinesData = figurinesData.figurines;
	
	    this.create();
	  }
	
	  _createClass(FigurineCarousel, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderCarousel();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "getImageSource",
	    value: function getImageSource(id) {
	      var requireKey = "./figurine_" + id + ".png";
	
	      if ($.inArray(requireKey, figurinesImages.keys()) !== -1) {
	        return figurinesImages(requireKey);
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderCarousel",
	    value: function renderCarousel() {
	      this.element.empty();
	
	      this.element.append("<button id='carousel-slider-prev' class='slider-btn slider-btn-prev'></button>");
	      this.element.append("<div id='figurines-carousel'></div>");
	      this.element.append("<button id='carousel-slider-next' class='slider-btn slider-btn-next'></button>");
	
	      var $carousel = $("#figurines-carousel");
	
	      for (var i = 0; i < this.figurinesData.length; ++i) {
	        var f = this.figurinesData[i];
	
	        var path = this.getImageSource(f.id);
	
	        var slide = $("<div class='figurine-slide'></div>");
	        slide.append($("<img src='" + path + "' data-id='" + f.id + "' >"));
	        slide.append($("<p>" + LanguageManager.getValueForKey("figurines." + f.id + ".name") + "</p>"));
	        slide.attr("data-figurine-id", f.id);
	        slide.attr("data-figurine-sex", f.sex);
	
	        $carousel.append(slide);
	      }
	
	      $carousel.slick({
	        centerMode: this.centered,
	        focusOnSelect: this.centered,
	        centerPadding: this.centered ? "60px" : "0",
	        mobileFirst: true,
	        draggable: false,
	        swipe: true,
	        infinite: true,
	        prevArrow: $("#carousel-slider-prev"),
	        nextArrow: $("#carousel-slider-next"),
	        slidesToShow: 6 + (this.centered ? 1 : 0),
	        slidesToScroll: 1,
	        responsive: [{
	          breakpoint: 1000,
	          settings: {
	            centerMode: true,
	            slidesToShow: 6 + (this.centered ? 1 : 0),
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 820,
	          settings: {
	            centerMode: true,
	            slidesToShow: 4 + (this.centered ? 1 : 2),
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 620,
	          settings: {
	            centerMode: true,
	            slidesToShow: 3 + (this.centered ? 0 : 1),
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 475,
	          settings: {
	            slidesToShow: this.centered ? 1 : 3,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 350,
	          settings: {
	            slidesToShow: this.centered ? 1 : 2,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 0,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }]
	      });
	
	      var startSlideIndex = $(".slick-slider").find(".figurine-slide[data-figurine-id=" + this.startAt + "]").closest(".slick-slide").data("slick-index");
	
	      if (startSlideIndex === null) startSlideIndex = 1;
	      $carousel.slick("slickGoTo", startSlideIndex);
	
	      if (this.clickCallBack !== undefined && utils.isFunction(this.clickCallBack)) {
	        $(".slick-slider").on("click", ".slick-slide", this.clickCallBack);
	        $(".slick-slider").on("mouseenter", ".slick-slide", function (e) {
	          var el = $(e.currentTarget).find(".figurine-slide img");
	          el.removeClass("hovered").addClass("hovered");
	        });
	        $(".slick-slider").on("mouseleave", ".slick-slide", function (e) {
	          var el = $(e.currentTarget).find(".figurine-slide img");
	          el.removeClass("hovered");
	        });
	      }
	
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {}
	  }]);
	
	  return FigurineCarousel;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _languageManager = __webpack_require__(38);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getText() {
	  return {
	    menu: {
	      title: _languageManager2.default.getValueForKey("games.carrot.game.title"),
	      controlsDescription: [_languageManager2.default.getValueForKey("games.carrot.game.description.line1"), _languageManager2.default.getValueForKey("games.carrot.game.description.line2")],
	      powerUps: {
	        shield: {
	          title: _languageManager2.default.getValueForKey("games.carrot.game.powerups.shield.title"),
	          description: [_languageManager2.default.getValueForKey("games.carrot.game.powerups.shield.description.line1"), _languageManager2.default.getValueForKey("games.carrot.game.powerups.shield.description.line2")]
	        },
	        springball: {
	          title: _languageManager2.default.getValueForKey("games.carrot.game.powerups.springball.title"),
	          description: [_languageManager2.default.getValueForKey("games.carrot.game.powerups.springball.description.line1"), _languageManager2.default.getValueForKey("games.carrot.game.powerups.springball.description.line2")]
	        },
	        rocketCake: {
	          title: _languageManager2.default.getValueForKey("games.carrot.game.powerups.rocket_cake.title"),
	          description: [_languageManager2.default.getValueForKey("games.carrot.game.powerups.rocket_cake.description.line1"), _languageManager2.default.getValueForKey("games.carrot.game.powerups.rocket_cake.description.line2")]
	        },
	        magnet: {
	          title: _languageManager2.default.getValueForKey("games.carrot.game.powerups.magnet.title"),
	          description: [_languageManager2.default.getValueForKey("games.carrot.game.powerups.magnet.description.line1"), _languageManager2.default.getValueForKey("games.carrot.game.powerups.magnet.description.line2")]
	        }
	      },
	      playBtn: _languageManager2.default.getValueForKey("games.carrot.game.start.btn"),
	      resumeBtn: _languageManager2.default.getValueForKey("games.carrot.game.resume.btn")
	    },
	    gameOver: {
	      title: _languageManager2.default.getValueForKey("games.carrot.game.gameover.title"),
	      highScore: _languageManager2.default.getValueForKey("games.carrot.game.gameover.highscore"),
	      replayBtn: _languageManager2.default.getValueForKey("games.carrot.game.gameover.replay.btn")
	    }
	  };
	} /**
	   * Created by jv on 25/05/2018.
	   */
	exports.default = getText;

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = init;
	
	var _phaser = __webpack_require__(313);
	
	var _phaser2 = _interopRequireDefault(_phaser);
	
	var _phaser3 = __webpack_require__(674);
	
	var _phaser4 = _interopRequireDefault(_phaser3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://github.com/rblopes/phaser-3-snake-game
	// https://photonstorm.github.io/phaser3-docs/list_namespace.html
	// https://labs.phaser.io/
	// http://localhost:9000/docs/boot_Config.js.html#line-104
	// http://codetuto.com/2018/02/getting-started-phaser-3-es6-create-boomdots-game/
	// https://github.com/CodeAndWeb/TexturePacker-Phaser3/blob/master/assets/cityscene.json
	// https://developer.amazon.com/post/Tx3AT4I2ENBOI6R/Intro-to-Phaser-Part-3-Obstacles-Collision-Score-Sound-and-Publishing
	// http://codetuto.com/2018/03/getting-started-phaser-3-es6-create-boomdots-game-part-2/
	// http://www.html5gamedevs.com/topic/36930-seperating-update-loop-of-game-from-update-loop-of-rendering/
	// https://hacks.mozilla.org/2016/06/webfont-preloading-for-html5-games/
	// http://www.html5gamedevs.com/topic/21724-spawning-enemies-at-random-period/
	
	/**
	 * Created by jv on 15/05/2018.
	 */
	function init(parent) {
	  _phaser4.default.parent = parent;
	
	  return new _phaser2.default.Game(_phaser4.default);
	}

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _languageManager = __webpack_require__(38);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getText() {
	  return {
	    menu: {
	      title: _languageManager2.default.getValueForKey("games.chicken.game.title"),
	      controlsDescription: [_languageManager2.default.getValueForKey("games.chicken.game.description.line1"), _languageManager2.default.getValueForKey("games.chicken.game.description.line2"), _languageManager2.default.getValueForKey("games.chicken.game.description.line3"), "", _languageManager2.default.getValueForKey("games.chicken.game.description.line5"), _languageManager2.default.getValueForKey("games.chicken.game.description.line6")],
	      playBtn: _languageManager2.default.getValueForKey("games.chicken.game.start.btn"),
	      resumeBtn: _languageManager2.default.getValueForKey("games.chicken.game.resume.btn")
	    },
	    gameOver: {
	      title: _languageManager2.default.getValueForKey("games.chicken.game.gameover.title"),
	      highScore: _languageManager2.default.getValueForKey("games.chicken.game.gameover.highscore"),
	      replayBtn: _languageManager2.default.getValueForKey("games.chicken.game.gameover.replay.btn")
	    }
	  };
	} /**
	   * Created by jv on 25/05/2018.
	   */
	exports.default = getText;

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = init;
	
	var _phaser = __webpack_require__(313);
	
	var _phaser2 = _interopRequireDefault(_phaser);
	
	var _phaser3 = __webpack_require__(687);
	
	var _phaser4 = _interopRequireDefault(_phaser3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://github.com/rblopes/phaser-3-snake-game
	// https://photonstorm.github.io/phaser3-docs/list_namespace.html
	// https://labs.phaser.io/
	// http://localhost:9000/docs/boot_Config.js.html#line-104
	// http://codetuto.com/2018/02/getting-started-phaser-3-es6-create-boomdots-game/
	// https://github.com/CodeAndWeb/TexturePacker-Phaser3/blob/master/assets/cityscene.json
	// https://developer.amazon.com/post/Tx3AT4I2ENBOI6R/Intro-to-Phaser-Part-3-Obstacles-Collision-Score-Sound-and-Publishing
	// http://codetuto.com/2018/03/getting-started-phaser-3-es6-create-boomdots-game-part-2/
	// http://www.html5gamedevs.com/topic/36930-seperating-update-loop-of-game-from-update-loop-of-rendering/
	// https://hacks.mozilla.org/2016/06/webfont-preloading-for-html5-games/
	// http://www.html5gamedevs.com/topic/21724-spawning-enemies-at-random-period/
	
	/**
	 * Created by jv on 30/05/2018.
	 */
	function init(parent) {
	  _phaser4.default.parent = parent;
	
	  return new _phaser2.default.Game(_phaser4.default);
	}

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = init;
	
	var _phaser = __webpack_require__(313);
	
	var _phaser2 = _interopRequireDefault(_phaser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var game = null;
	
	var STD_MIN_TIME = 1000;
	var STD_TIME_DELAY = 3000;
	var STD_TIME_DECREASE = 50;
	
	var cursors;
	
	var LANG_NL = "nl-BE";
	var LANG_FR = "fr-BE";
	
	var locale = LANG_NL;
	var languageManager;
	var swipeManager;
	
	var positions = [100, 230, 360, 475, 605, 730, 860];
	var middle = Math.floor(positions.length / 2);
	var timeDecrease = STD_TIME_DECREASE;
	var timeDelay = STD_TIME_DELAY;
	var minTime = STD_MIN_TIME;
	var gameOver = false;
	var playtime = 0;
	
	var crows = [];
	var CrowPool;
	
	var seeds = [{ type: 2, x: 80, y: 430, row: 0, active: true, image: null }, { type: 4, x: 40, y: 465, row: 0, active: true, image: null }, { type: 1, x: 220, y: 450, row: 1, active: true, image: null }, { type: 3, x: 170, y: 510, row: 1, active: true, image: null }, { type: 1, x: 350, y: 465, row: 2, active: true, image: null }, { type: 4, x: 350, y: 465, row: 2, active: true, image: null }, { type: 5, x: 350, y: 520, row: 2, active: true, image: null }, { type: 5, x: 470, y: 450, row: 3, active: true, image: null }, { type: 2, x: 480, y: 510, row: 3, active: true, image: null }, { type: 4, x: 605, y: 435, row: 4, active: true, image: null }, { type: 1, x: 620, y: 510, row: 4, active: true, image: null }, { type: 5, x: 720, y: 440, row: 5, active: true, image: null }, { type: 3, x: 750, y: 490, row: 5, active: true, image: null }, { type: 2, x: 780, y: 505, row: 5, active: true, image: null }, { type: 1, x: 900, y: 450, row: 6, active: true, image: null }, { type: 5, x: 940, y: 490, row: 6, active: true, image: null }];
	
	var scarecrowGameAtlas = __webpack_require__(1637);
	var scarecrowGameAtlasJson = __webpack_require__(986);
	
	var Game = function (_Phaser$Scene) {
	  _inherits(Game, _Phaser$Scene);
	
	  function Game() {
	    _classCallCheck(this, Game);
	
	    var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this, { key: "Game" }));
	
	    _this.bestTime = 0;
	    return _this;
	  }
	
	  _createClass(Game, [{
	    key: "init",
	    value: function init() {
	      this.scene.launch("ScarecrowGame", { gameScene: this }).launch("InGameMenu", { gameScene: this });
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.scarecrowGame = this.scene.get("ScarecrowGame");
	      this.ingameMenu = this.scene.get("InGameMenu");
	
	      this.setSceneOrder();
	
	      this.cursors = this.input.keyboard.addKeys({
	        leftKey: _phaser2.default.Input.Keyboard.KeyCodes.LEFT,
	        rightKey: _phaser2.default.Input.Keyboard.KeyCodes.RIGHT
	      });
	
	      this.scarecrowGame.events.off("pauseGame").on("pauseGame", this.showInfo, this);
	      this.scarecrowGame.events.off("endGame").on("endGame", this.endGame, this);
	      this.ingameMenu.events.off("continueGame").on("continueGame", this.hideInfo, this);
	      this.ingameMenu.events.off("restartGame").on("restartGame", this.restartGame, this);
	    }
	  }, {
	    key: "setSceneOrder",
	    value: function setSceneOrder() {
	      this.scene.bringToTop("InGameMenu");
	      this.scene.bringToTop("ScarecrowGame");
	    }
	  }, {
	    key: "update",
	    value: function update(time, delta) {
	      this.scarecrowGame.updateInput(this.cursors);
	    }
	  }, {
	    key: "showInfo",
	    value: function showInfo() {
	      this.scarecrowGame.pause(true);
	      this.ingameMenu.showMenu(PAUSE_MENU);
	      this.scene.bringToTop("InGameMenu");
	    }
	  }, {
	    key: "hideInfo",
	    value: function hideInfo() {
	      this.scene.bringToTop("ScarecrowGame");
	      this.ingameMenu.hide();
	      this.scarecrowGame.pause(false);
	    }
	  }, {
	    key: "restartGame",
	    value: function restartGame() {
	      this.scarecrowGame.restart();
	      this.ingameMenu.hide();
	      this.scene.bringToTop("ScarecrowGame");
	    }
	  }, {
	    key: "endGame",
	    value: function endGame(time) {
	      this.scarecrowGame.infoBtnZone.removeInteractive();
	      this.scarecrowGame.pause(true);
	      this.ingameMenu.showMenu(END_MENU);
	      this.ingameMenu.setScore(time);
	      this.scene.bringToTop("InGameMenu");
	    }
	  }]);
	
	  return Game;
	}(_phaser2.default.Scene);
	
	var ScarecrowGame = function (_Phaser$Scene2) {
	  _inherits(ScarecrowGame, _Phaser$Scene2);
	
	  function ScarecrowGame() {
	    _classCallCheck(this, ScarecrowGame);
	
	    return _possibleConstructorReturn(this, (ScarecrowGame.__proto__ || Object.getPrototypeOf(ScarecrowGame)).call(this, { key: "ScarecrowGame" }));
	  }
	
	  _createClass(ScarecrowGame, [{
	    key: "init",
	    value: function init() {}
	  }, {
	    key: "create",
	    value: function create() {
	
	      this.add.image(0, 0, 'scarecrow', 'scene/sky.jpg');
	      this.add.sprite(0, 300, 'scarecrow', 'scene/back.png');
	      this.add.sprite(0, 332, 'scarecrow', 'scene/front.png');
	      var infoBtn = this.add.sprite(40, 40, 'scarecrow', 'interface/info.png');
	
	      var prepareJumpFrames = this.anims.generateFrameNames('scarecrow', {
	        start: 1,
	        end: 2,
	        zeroPad: 2,
	        prefix: 'victor/victor_',
	        suffix: '.png'
	      });
	      this.anims.create({
	        key: 'prepareJumpLeft',
	        frames: prepareJumpFrames,
	        frameRate: 10,
	        repeat: 0,
	        onComplete: this.jump,
	        onCompleteParams: [this, -1]
	      });
	      this.anims.create({
	        key: 'prepareJumpRight',
	        frames: prepareJumpFrames,
	        frameRate: 10,
	        repeat: 0,
	        onComplete: this.jump,
	        onCompleteParams: [this, 1]
	      });
	      var jumpUpFrames = this.anims.generateFrameNames('scarecrow', {
	        start: 2,
	        end: 3,
	        zeroPad: 2,
	        prefix: 'victor/victor_',
	        suffix: '.png'
	      });
	      this.anims.create({ key: 'jumpUp', frames: jumpUpFrames, frameRate: 60, repeat: 0 });
	      var comeDownFrames = this.anims.generateFrameNames('scarecrow', {
	        start: 4,
	        end: 6,
	        zeroPad: 2,
	        prefix: 'victor/victor_',
	        suffix: '.png'
	      });
	      this.anims.create({
	        key: 'comeDown', frames: comeDownFrames, frameRate: 10, repeat: 0, onComplete: this.jumpEnded, onCompleteParams: [this]
	      });
	
	      this.timerText = this.add.text(game.config.width - 120, 10, '00:00', { font: '48px RabbitOnTheMoon', fill: '#8BB000' });
	
	      for (var i = 0; i < seeds.length; i++) {
	        seeds[i].image = this.add.sprite(seeds[i].x, seeds[i].y, 'scarecrow', 'seeds/seed_0' + seeds[i].type + '.png');
	      }
	
	      this.player = new Victor(this, config.width / 2, 445, middle);
	
	      this.ground = this.physics.add.staticGroup();
	      var floor = this.add.sprite(400, 460);
	      floor.displayWidth = 800;
	      this.ground.add(floor);
	      this.ground.refresh();
	      this.physics.add.collider(this.player.sprite, this.ground);
	
	      cursors = this.input.keyboard.createCursorKeys();
	
	      CrowPool = this.add.group({ classType: Crow, maxSize: positions.length, runChildUpdate: false });
	
	      this.playtime = 0;
	      this.gameTick = this.time.addEvent({ delay: 1000, callback: this.tick, callbackScope: this, loop: true });
	
	      this.events.off("scare-birds").on("scare-birds", this.scareBirds);
	
	      this.infoBtnZone = this.add.zone(infoBtn.x - infoBtn.width * infoBtn.originX - 5, infoBtn.y - infoBtn.height * infoBtn.originY - 5, infoBtn.width + 10, infoBtn.height + 10).setName("info-button");
	
	      this.setInfoBtnEvent();
	      this.infoBtnZone.setInteractive();
	
	      this.input.on("gameobjectover", function (pointer, gameObject) {
	        if (gameObject.name === "info-button") {
	          this.mouse.target.style.cursor = "pointer";
	        }
	      });
	
	      this.input.on("gameobjectout", function (pointer, gameObject) {
	        if (gameObject.name === "info-button") {
	          this.mouse.target.style.cursor = "";
	        }
	      });
	
	      this.paused = false;
	      this.gameOver = false;
	      swipeManager.setCallback(this, this.swipeCallback);
	    }
	  }, {
	    key: "setInfoBtnEvent",
	    value: function setInfoBtnEvent() {
	      var _this3 = this;
	
	      this.infoBtnZone.on("pointerup", function () {
	        _this3.input.mouse.target.style.cursor = "";
	        _this3.events.emit("pauseGame");
	      });
	    }
	  }, {
	    key: "update",
	    value: function update() {
	      if (!this.gameOver && !this.paused) {
	
	        if (cursors.left.isDown && this.player.row > 0 && !this.player.jumping) {
	          this.player.prepareJump(-1);
	        } else if (cursors.right.isDown && this.player.row < positions.length - 1 && !this.player.jumping) {
	          this.player.prepareJump(1);
	        }
	        if (this.spawnTimer == null && !this.gameOver && !this.paused) {
	          this.spawnTimer = this.time.delayedCall(Math.random() * timeDelay + minTime, this.spawnBird, [], this);
	        }
	
	        if (this.input.activePointer.isDown) {
	          swipeManager.swipeInput(this.input.activePointer);
	        } else {
	          swipeManager.endSwipe();
	        }
	      }
	    }
	  }, {
	    key: "swipeCallback",
	    value: function swipeCallback(scene, direction) {
	      console.log("swipeCallback received");
	      scene.player.prepareJump(direction);
	    }
	  }, {
	    key: "updateInput",
	    value: function updateInput(cursors) {}
	  }, {
	    key: "pause",
	    value: function pause(state) {
	      this.paused = state;
	      if (state) this.tweens.pauseAll();else this.tweens.resumeAll();
	
	      for (var i = 0; i < crows.length; i++) {
	        crows[i].crow.pause(state);
	      }
	    }
	  }, {
	    key: "tick",
	    value: function tick() {
	      if (!this.paused && !this.gameOver) {
	        this.playtime++;
	        this.timerText.setText(('0' + Math.floor(this.playtime / 60)).slice(-2) + ':' + ('0' + this.playtime % 60).slice(-2));
	        this.scareBirds();
	        this.checkGameOver();
	      }
	    }
	  }, {
	    key: "checkGameOver",
	    value: function checkGameOver() {
	      var activeRows = [];
	      for (var i = 0; i < seeds.length; i++) {
	        if (seeds[i].active && activeRows.indexOf(seeds[i].row) == -1) activeRows.push(seeds[i].row);
	      }
	      if (activeRows.length <= positions.length / 2) {
	        this.gameOver = true;
	        this.events.emit("endGame", this.playtime);
	      }
	    }
	  }, {
	    key: "restart",
	    value: function restart() {
	      this.infoBtnZone.setInteractive();
	      this.playtime = 0;
	      this.timerText.setText(('0' + Math.floor(this.playtime / 60)).slice(-2) + ':' + ('0' + this.playtime % 60).slice(-2));
	
	      for (var i = 0; i < seeds.length; i++) {
	        seeds[i].active = true;
	        seeds[i].image.setVisible(true);
	      }
	
	      /*this.tweens.killAll();*/
	
	      CrowPool.clear();
	
	      for (var j = 0; j < crows.length; j++) {
	        crows[j].crow.setVisible(false);
	        crows[j].crow.destroy();
	      }
	      crows = [];
	
	      CrowPool = this.add.group({ classType: Crow, maxSize: positions.length, runChildUpdate: false });
	
	      this.player.reset();
	
	      timeDecrease = STD_TIME_DECREASE;
	      timeDelay = STD_TIME_DELAY;
	      minTime = STD_MIN_TIME;
	      this.gameOver = false;
	      this.pause(false);
	    }
	  }, {
	    key: "jump",
	    value: function jump(sprite, animation, scene, direction) {
	
	      var originalY = scene.player.sprite.body.y;
	      scene.tweens.add({
	        targets: scene.player.sprite,
	        x: positions[scene.player.row + direction],
	        ease: 'Linear',
	        duration: 500,
	        onComplete: scene.finalizeJump,
	        onCompleteParams: [scene]
	      });
	
	      scene.tweens.add({
	        targets: scene.player.sprite,
	        y: 410,
	        ease: 'Back.easeOut',
	        duration: 400
	      });
	
	      scene.player.row += direction;
	      scene.player.sprite.anims.play('jumpUp');
	    }
	  }, {
	    key: "finalizeJump",
	    value: function finalizeJump(tween, targets, scene) {
	      scene.player.finalizeJump();
	      scene.scareBirds();
	    }
	  }, {
	    key: "jumpEnded",
	    value: function jumpEnded(sprite, animation, scene) {
	      scene.player.jumping = false;
	    }
	  }, {
	    key: "scareBirds",
	    value: function scareBirds() {
	      var newArray = [];
	      for (var i = 0; i < crows.length; i++) {
	        if (crows[i].row == this.player.row || crows[i].crow.seed.active == false) {
	          crows[i].crow.flyOff();
	        } else newArray.push(crows[i]);
	      }
	      crows = newArray;
	    }
	  }, {
	    key: "spawnBird",
	    value: function spawnBird() {
	      if (!this.paused && !this.gameOver) {
	        var crowTarget = this.getFreeRowAndSeed();
	        if (crowTarget.spawnRow >= 0 && crowTarget.seed != null) {
	          //this.spawning = true;
	          var crow = CrowPool.get();
	          if (crow) {
	            crow.launch(crowTarget.spawnRow, crowTarget.seed);
	            crows.push({ crow: crow, row: crowTarget.spawnRow });
	          }
	        }
	        this.timeDelay -= Math.random() * timeDecrease;
	      }
	      this.spawnTimer.destroy();
	      this.spawnTimer = null;
	    }
	  }, {
	    key: "getFreeRowAndSeed",
	    value: function getFreeRowAndSeed() {
	      var possibilities = [];
	      for (var i = 0; i < positions.length; i++) {
	        var available = true;
	        for (var j = 0; j < crows.length; j++) {
	          if (crows[j].row == i) available = false;
	        }
	        if (available && i != this.player.row) {
	          //suitable row, check available seeds
	          var seed = this.getSeed(i);
	          if (seed != null) possibilities.push({ spawnRow: i, seed: seed });
	        }
	      }
	      if (possibilities.length > 0) return possibilities[Math.floor(Math.random() * possibilities.length)];else return -1;
	    }
	  }, {
	    key: "getSeed",
	    value: function getSeed(row) {
	      var possibilities = [];
	      for (var i = 0; i < seeds.length; i++) {
	        if (seeds[i].row == row && seeds[i].active == true) possibilities.push(seeds[i]);
	      }
	      if (possibilities.length > 0) return possibilities[Math.floor(Math.random() * possibilities.length)];else return null;
	    }
	  }]);
	
	  return ScarecrowGame;
	}(_phaser2.default.Scene);
	
	var Victor = function () {
	  function Victor(scene, x, y, row) {
	    _classCallCheck(this, Victor);
	
	    this.scene = scene;
	    this.sprite = this.scene.physics.add.sprite(x, y, 'scarecrow', 'victor/victor_01.png');
	    this.jumping = false;
	    this.row = row;
	    this.direction = 0;
	    this.sprite.setBounce(0);
	    this.sprite.setCollideWorldBounds(true);
	    this.origin = { x: this.sprite.body.x, y: this.sprite.body.y, row: row };
	
	    this.sprite.on("animationcomplete", this.onAnimComplete, this);
	  }
	
	  _createClass(Victor, [{
	    key: "onAnimComplete",
	    value: function onAnimComplete(animation, frame) {
	      if (animation.key === "prepareJumpLeft") {
	        this.scene.jump(frame, animation, this.scene, -1);
	      } else if (animation.key === "prepareJumpRight") {
	        this.scene.jump(frame, animation, this.scene, 1);
	      } else if (animation.key === "comeDown") {
	        this.scene.jumpEnded(frame, animation, this.scene);
	      }
	    }
	  }, {
	    key: "prepareJump",
	    value: function prepareJump(direction) {
	      if (!this.jumping) {
	        this.jumping = true;
	        this.direction = direction;
	        if (direction < 0) this.sprite.anims.play('prepareJumpLeft');else this.sprite.anims.play('prepareJumpRight');
	      }
	    }
	  }, {
	    key: "finalizeJump",
	    value: function finalizeJump() {
	      this.sprite.anims.play('comeDown');
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.sprite.anims.play('comeDown');
	      this.sprite.setPosition(this.origin.x, this.origin.y);
	      this.jumping = false;
	      this.row = this.origin.row;
	      this.direction = 0;
	    }
	  }]);
	
	  return Victor;
	}();
	
	var Loader = function (_Phaser$Scene3) {
	  _inherits(Loader, _Phaser$Scene3);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).call(this, { key: "Loader" }));
	  }
	
	  _createClass(Loader, [{
	    key: "init",
	    value: function init() {
	      this.add.text(this.sys.game.config.width / 2, this.sys.game.config.height / 2, "Loading...", {
	        fontFamily: "RabbitOnTheMoon",
	        fontSize: 18,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	    }
	  }, {
	    key: "preload",
	    value: function preload() {
	      this.load.atlas('scarecrow', scarecrowGameAtlas, scarecrowGameAtlasJson);
	      this.loadFonts();
	    }
	  }, {
	    key: "create",
	    value: function create() {
	
	      var landFrames = this.anims.generateFrameNames('scarecrow', {
	        start: 1,
	        end: 3,
	        zeroPad: 2,
	        prefix: 'bird/bird_',
	        suffix: '.png'
	      });
	      this.anims.create({
	        key: 'land', frames: landFrames, frameRate: 2, repeat: 0, onComplete: function onComplete() {}
	      });
	      var peckFrames = this.anims.generateFrameNames('scarecrow', {
	        start: 3,
	        end: 4,
	        zeroPad: 2,
	        prefix: 'bird/bird_',
	        suffix: '.png'
	      }).concat(this.anims.generateFrameNames('scarecrow', {
	        start: 3,
	        end: 3,
	        zeroPad: 2,
	        prefix: 'bird/bird_',
	        suffix: '.png'
	      }));
	      this.anims.create({
	        key: 'peck', frames: peckFrames, frameRate: 10, repeat: 0, onComplete: function onComplete() {}
	      });
	      var flyOffFrames = this.anims.generateFrameNames('scarecrow', {
	        start: 1,
	        end: 6,
	        zeroPad: 2,
	        prefix: 'bird/fly_',
	        suffix: '.png'
	      }).concat(this.anims.generateFrameNames('scarecrow', {
	        start: 3,
	        end: 6,
	        zeroPad: 2,
	        prefix: 'bird/fly_',
	        suffix: '.png'
	      }));
	      this.anims.create({
	        key: 'flyOff', frames: flyOffFrames, frameRate: 5, repeat: 0, onComplete: function onComplete() {}
	      });
	
	      languageManager = new LanguageManager(locale);
	      swipeManager = new SwipeManager();
	
	      this.scene.start("Menu");
	    }
	  }, {
	    key: "loadFonts",
	    value: function loadFonts() {
	      this.preloadFont("RabbitOnTheMoon");
	      this.preloadFont("AbadiMTPro-CondExtraBold");
	    }
	  }, {
	    key: "preloadFont",
	    value: function preloadFont(font) {
	      var text = this.add.text(0, 0, "text", { fontFamily: font, fontSize: 1, fill: "#FFFFFF" });
	      text.visible = false;
	    }
	  }]);
	
	  return Loader;
	}(_phaser2.default.Scene);
	
	var Menu = function (_Phaser$Scene4) {
	  _inherits(Menu, _Phaser$Scene4);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, { key: "Menu" }));
	  }
	
	  _createClass(Menu, [{
	    key: "init",
	    value: function init() {}
	  }, {
	    key: "create",
	    value: function create() {
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.add.image(0, 0, 'scarecrow', 'scene/sky.jpg');
	      this.add.sprite(0, 330, 'scarecrow', 'scene/back.png');
	      this.add.sprite(0, 362, 'scarecrow', 'scene/front.png');
	      this.add.image(0, 0, 'scarecrow', 'interface/background_overlay.png');
	      this.add.image(0, 0, 'scarecrow', 'interface/background_cloud.png');
	      this.add.image(gameWidth / 2, gameHeight * 0.6, 'scarecrow', 'interface/paint_green.png');
	      this.add.image(gameWidth / 2, gameHeight * 0.6, 'scarecrow', 'interface/birds.png');
	      var buttonImage = this.add.image(gameWidth / 2, gameHeight * 0.9, 'scarecrow', 'interface/button.png');
	
	      var playicon = this.add.image(gameWidth / 2, gameHeight * 0.9, 'scarecrow', 'interface/icon_play.png');
	      var text = this.add.text(gameWidth / 2, gameHeight * 0.9, "  " + languageManager.getText().menu.button, {
	        fontFamily: "RabbitOnTheMoon",
	        fontSize: 20,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	      var fullWidth = playicon.width + text.width;
	      playicon.setPosition(gameWidth / 2 - fullWidth / 2 + playicon.width / 2, gameHeight * 0.9);
	      text.setPosition(gameWidth / 2 + playicon.width * 0.5, gameHeight * 0.9 + playicon.height / 10);
	
	      this.add.text(gameWidth / 2, gameHeight * 0.15, languageManager.getText().menu.title, {
	        fontFamily: "RabbitOnTheMoon",
	        fontSize: 30,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	      var description = this.add.text(gameWidth / 2, gameHeight * 0.3, languageManager.getText().menu.description, {
	        fontFamily: "AbadiMTPro-CondExtraBold",
	        fontSize: 18,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	
	      this.add.image(description.x + description.width / 2, description.y + description.height * 0.75, 'scarecrow', 'interface/icon_gameplay.png').setOrigin(0, 1);
	
	      this.playBtnZone = this.add.zone(buttonImage.x - buttonImage.width * buttonImage.originX - 5, buttonImage.y - buttonImage.height * buttonImage.originY - 5, buttonImage.width + 10, buttonImage.height + 10).setName("play-button");
	
	      this.setPlayBtnEvent();
	      this.playBtnZone.setInteractive();
	
	      this.input.on("gameobjectover", function (pointer, gameObject) {
	        if (gameObject.name === "play-button") {
	          this.mouse.target.style.cursor = "pointer";
	        }
	      });
	
	      this.input.on("gameobjectout", function (pointer, gameObject) {
	        if (gameObject.name === "play-button") {
	          this.mouse.target.style.cursor = "";
	        }
	      });
	    }
	  }, {
	    key: "setPlayBtnEvent",
	    value: function setPlayBtnEvent() {
	      var _this6 = this;
	
	      this.playBtnZone.once("pointerup", function () {
	        _this6.input.mouse.target.style.cursor = "";
	        _this6.scene.start("Game");
	      });
	    }
	  }]);
	
	  return Menu;
	}(_phaser2.default.Scene);
	
	var PAUSE_MENU = "pause-menu";
	var END_MENU = "end-menu";
	
	var InGameMenu = function (_Phaser$Scene5) {
	  _inherits(InGameMenu, _Phaser$Scene5);
	
	  function InGameMenu() {
	    _classCallCheck(this, InGameMenu);
	
	    return _possibleConstructorReturn(this, (InGameMenu.__proto__ || Object.getPrototypeOf(InGameMenu)).call(this, { key: "InGameMenu" }));
	  }
	
	  _createClass(InGameMenu, [{
	    key: "init",
	    value: function init() {}
	  }, {
	    key: "create",
	    value: function create() {
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.add.image(0, 0, 'scarecrow', 'scene/sky.jpg');
	      this.add.sprite(0, 300, 'scarecrow', 'scene/back.png');
	      this.add.sprite(0, 332, 'scarecrow', 'scene/front.png');
	      this.add.image(0, 0, 'scarecrow', 'interface/background_overlay.png');
	
	      this.bestTime = 0;
	      this.bestTimeLabel;
	
	      this.pauseGroup = this.add.group();
	      this.endGameGroup = this.add.group();
	
	      this.createEndGameMenu(gameWidth, gameHeight);
	      this.createPauseMenu(gameWidth, gameHeight);
	
	      this.hide();
	    }
	  }, {
	    key: "continue",
	    value: function _continue(scene) {
	      scene.events.emit("continueGame");
	    }
	  }, {
	    key: "restart",
	    value: function restart(scene) {
	      scene.events.emit("restartGame");
	    }
	  }, {
	    key: "showMenu",
	    value: function showMenu(type) {
	      if (type == PAUSE_MENU) {
	        this.setVisibility(this.endGameGroup, false);
	        this.setVisibility(this.pauseGroup, true);
	      } else {
	        this.setVisibility(this.endGameGroup, true);
	        this.setVisibility(this.pauseGroup, false);
	      }
	    }
	  }, {
	    key: "createEndGameMenu",
	    value: function createEndGameMenu(gameWidth, gameHeight) {
	      var restartButton = new UIButton(this, gameWidth / 2, gameHeight * 0.8, "replay-button", this.restart);
	      this.endGameGroup.add(restartButton.buttonImage);
	      this.endGameGroup.add(restartButton.uiBtnZone);
	
	      var playicon = this.add.image(gameWidth / 2, gameHeight * 0.8, 'scarecrow', 'interface/icon_restart.png');
	      var text = this.add.text(gameWidth / 2, gameHeight * 0.8, "  " + languageManager.getText().gameOver.retry, {
	        fontFamily: "AbadiMTPro-CondExtraBold",
	        fontSize: 20,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	      var fullWidth = playicon.width + text.width;
	      playicon.setPosition(gameWidth / 2 - fullWidth / 2 + playicon.width / 2, gameHeight * 0.8);
	      text.setPosition(gameWidth / 2 + playicon.width * 0.5, gameHeight * 0.8);
	
	      this.endGameGroup.add(playicon);
	      this.endGameGroup.add(text);
	
	      this.endGameGroup.add(this.add.text(gameWidth / 2, gameHeight * 0.25, languageManager.getText().gameOver.title, {
	        fontFamily: "RabbitOnTheMoon",
	        fontSize: 50,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5));
	
	      this.bestTimeLabel = this.add.text(gameWidth / 2, gameHeight * 0.5, languageManager.getText().gameOver.time + " 00:00", {
	        fontFamily: "RabbitOnTheMoon",
	        fontSize: 35,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	
	      this.endGameGroup.add(this.bestTimeLabel);
	    }
	  }, {
	    key: "createPauseMenu",
	    value: function createPauseMenu(gameWidth, gameHeight) {
	
	      var continueButton = new UIButton(this, gameWidth / 2, gameHeight * 0.65, "continue-button", this.continue);
	      this.pauseGroup.add(continueButton.buttonImage);
	      this.pauseGroup.add(continueButton.uiBtnZone);
	
	      var restartButton = new UIButton(this, gameWidth / 2, gameHeight * 0.8, "restart-button", this.restart);
	      this.pauseGroup.add(restartButton.buttonImage);
	      this.pauseGroup.add(restartButton.uiBtnZone);
	
	      var playIcon = this.add.image(gameWidth / 2, gameHeight * 0.65, 'scarecrow', 'interface/icon_play.png');
	      var continueText = this.add.text(gameWidth / 2, gameHeight * 0.65, "  " + languageManager.getText().pauze.continue, {
	        fontFamily: "AbadiMTPro-CondExtraBold",
	        fontSize: 20,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	      var fullWidth = playIcon.width + continueText.width;
	      playIcon.setPosition(gameWidth / 2 - fullWidth / 2 + playIcon.width / 2, gameHeight * 0.65);
	      continueText.setPosition(gameWidth / 2 + playIcon.width * 0.5, gameHeight * 0.65);
	
	      this.pauseGroup.add(playIcon);
	      this.pauseGroup.add(continueText);
	
	      var restartIcon = this.add.image(gameWidth / 2, gameHeight * 0.8, 'scarecrow', 'interface/icon_restart.png');
	      var restartText = this.add.text(gameWidth / 2, gameHeight * 0.8, "  " + languageManager.getText().pauze.replay, {
	        fontFamily: "AbadiMTPro-CondExtraBold",
	        fontSize: 20,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5);
	      var fullWidth = restartIcon.width + restartText.width;
	      restartIcon.setPosition(gameWidth / 2 - fullWidth / 2 + restartIcon.width / 2, gameHeight * 0.8);
	      restartText.setPosition(gameWidth / 2 + restartIcon.width * 0.5, gameHeight * 0.8);
	
	      this.pauseGroup.add(restartIcon);
	      this.pauseGroup.add(restartText);
	
	      this.pauseGroup.add(this.add.text(gameWidth / 2, gameHeight * 0.25, languageManager.getText().pauze.title, {
	        fontFamily: "RabbitOnTheMoon",
	        fontSize: 80,
	        fontWeight: "normal",
	        fill: "#FFFFFF"
	      }).setOrigin(0.5));
	    }
	  }, {
	    key: "setVisibility",
	    value: function setVisibility(group, state) {
	      var children = group.getChildren();
	      for (var i = 0; i < children.length; i++) {
	        children[i].setVisible(state);
	      }
	    }
	  }, {
	    key: "setScore",
	    value: function setScore(time) {
	      if (this.bestTime < time) this.bestTime = time;
	      this.bestTimeLabel.setText(languageManager.getText().gameOver.time + " " + ('0' + Math.floor(this.bestTime / 60)).slice(-2) + ':' + ('0' + this.bestTime % 60).slice(-2));
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.setVisibility(this.endGameGroup, false);
	      this.setVisibility(this.pauseGroup, false);
	    }
	  }]);
	
	  return InGameMenu;
	}(_phaser2.default.Scene);
	
	var UIButton = function () {
	  function UIButton(scene, x, y, name, callback) {
	    _classCallCheck(this, UIButton);
	
	    this.buttonImage = scene.add.image(x, y, 'scarecrow', 'interface/button.png');
	
	    this.uiBtnZone = scene.add.zone(this.buttonImage.x - this.buttonImage.width * this.buttonImage.originX - 5, this.buttonImage.y - this.buttonImage.height * this.buttonImage.originY - 5, this.buttonImage.width + 10, this.buttonImage.height + 10).setName(name);
	
	    this.uiBtnZone.setInteractive();
	
	    scene.input.on("gameobjectover", function (pointer, gameObject) {
	      if (gameObject.name === name) {
	        scene.input.mouse.target.style.cursor = "pointer";
	      }
	    });
	
	    scene.input.on("gameobjectout", function (pointer, gameObject) {
	      if (gameObject.name === name) {
	        scene.input.mouse.target.style.cursor = "";
	      }
	    });
	
	    this.uiBtnZone.on("pointerup", function () {
	      console.log("pointerup triggered");
	      scene.input.mouse.target.style.cursor = "";
	      callback(scene);
	    });
	  }
	
	  _createClass(UIButton, [{
	    key: "setVisible",
	    value: function setVisible(state) {
	      this.buttonImage.setVisible(state);
	      this.setInteractive(state);
	    }
	  }, {
	    key: "setInteractive",
	    value: function setInteractive(state) {
	      this.uiBtnZone.input.enabled = state;
	    }
	  }]);
	
	  return UIButton;
	}();
	
	var Crow = function (_Phaser$GameObjects$S) {
	  _inherits(Crow, _Phaser$GameObjects$S);
	
	  function Crow(scene) {
	    var _this8;
	
	    _classCallCheck(this, Crow);
	
	    (_this8 = _possibleConstructorReturn(this, (Crow.__proto__ || Object.getPrototypeOf(Crow)).call(this, scene, 0, 0, 'scarecrow', 'bird/bird_01.png')), _this8).setScale(0.8);
	    _this8.peckCooldown = Math.random() * 500 + 750;
	    _this8.timedEvent = null;
	    _this8.fedEvent = null;
	    _this8.direction = 1;
	    _this8.seed = null;
	    _this8.scared = false;
	    _this8.paused = false;
	    return _this8;
	  }
	
	  _createClass(Crow, [{
	    key: "launch",
	    value: function launch(row, seed) {
	      this.seed = seed;
	      this.scared = false;
	      var offset = config.width / 4;
	      //determine initial direction
	      if (row <= middle) {
	        offset = -offset;
	        this.direction = -1;
	      }
	      //flip direction for outer fields
	      if (row == 0 || row == positions.length - 1) {
	        offset = -offset;
	        this.direction = -this.direction;
	      }
	      this.scaleX = this.direction * this.scaleX;
	
	      this.setPosition(positions[row] + offset, -50);
	      this.setActive(true);
	      this.setVisible(true);
	      this.anims.play('land');
	
	      this.scene.tweens.add({
	        targets: this,
	        x: seed.x + seed.image.width / 2 * this.scaleX,
	        ease: 'Quad.easeIn',
	        duration: 1000,
	        onComplete: function onComplete() {}
	      });
	
	      this.scene.tweens.add({
	        targets: this,
	        y: seed.y,
	        ease: 'Quad.easeOut',
	        duration: 1000,
	        onComplete: function onComplete() {
	          for (var i = 0; i < this.targets.length; i++) {
	            this.targets[i].landCrow();
	          }
	        }
	      });
	    }
	  }, {
	    key: "update",
	    value: function update() {}
	  }, {
	    key: "landCrow",
	    value: function landCrow() {
	      if (!this.scared && !this.paused) {
	        this.doPeck();
	        this.fedEvent = this.scene.time.delayedCall(Math.random() * (STD_TIME_DELAY / 2) + STD_MIN_TIME, this.hasFed, [], this);
	      }
	    }
	  }, {
	    key: "flyOff",
	    value: function flyOff() {
	      this.scared = true;
	      if (this.timedEvent) this.timedEvent.destroy();
	      if (this.fedEvent) this.fedEvent.destroy();
	      this.anims.play('flyOff');
	
	      var offscreen = game.config.width + this.x;
	      if (this.direction > 0) offscreen = this.x - game.config.width;
	
	      this.scene.tweens.add({
	        targets: this,
	        x: offscreen,
	        ease: 'Quad.easeIn',
	        duration: 1500,
	        onComplete: function onComplete() {}
	      });
	
	      this.scene.tweens.add({
	        targets: this,
	        y: Math.random() * 200,
	        ease: 'Quad.easeOut',
	        duration: 2000,
	        onComplete: function onComplete() {
	          for (var i = 0; i < this.targets.length; i++) {
	            this.targets[i].remove();
	          }
	        }
	      });
	    }
	  }, {
	    key: "doPeck",
	    value: function doPeck() {
	      if (!this.scared && this.active) {
	        this.anims.play('peck');
	        this.peckCooldown = Math.random() * 800 + 100;
	        this.timedEvent = this.scene.time.delayedCall(this.peckCooldown, this.doPeck, [], this);
	      }
	    }
	  }, {
	    key: "hasFed",
	    value: function hasFed() {
	      if (this.seed != null && !this.scared && !this.paused) {
	        this.seed.image.setVisible(false);
	        this.seed.active = false;
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove() {
	      this.setPosition(-50, -50);
	      if (this.timedEvent) this.timedEvent.destroy();
	      if (this.fedEvent) this.fedEvent.destroy();
	      this.scaleX = 0.8;
	      this.direction = 1;
	      this.seed = null;
	      this.paused = false;
	      this.active = false;
	      this.visible = false;
	    }
	  }, {
	    key: "pause",
	    value: function pause(state) {
	      //if the fedEvent is live, cancel it when pause is triggered
	      if (this.fedEvent) {
	        if (state) {
	          this.fedEvent.paused = true;
	          this.fedEvent.remove();
	          this.fedEvent.destroy();
	        }
	      } else this.paused && !state; //if current state switches from paused to live, create a new fedEvent
	      {
	        this.fedEvent = this.scene.time.delayedCall(Math.random() * (STD_TIME_DELAY / 2) + STD_MIN_TIME, this.hasFed, [], this);
	        this.doPeck();
	      }
	      this.paused = state;
	    }
	  }]);
	
	  return Crow;
	}(_phaser2.default.GameObjects.Sprite);
	
	var NL = {
	  menu: {
	    title: "PROBEER DE ZAADJES TE REDDEN!",
	    description: ["Swipe naar links of rechts op je scherm of duw op de pijltjestoetsen", "om Viktor de vogelverschrikker te laten springen. Jaag alle vogels", "weg voor ze de zaadjes oppikken en de oogst mislukt. Het spel", "stopt wanneer vier rijen geen zaadjes hebben."],
	    button: "Start het spel"
	  },
	  pauze: {
	    title: "PAUZE",
	    continue: "Verder spelen",
	    replay: "Nieuw spel starten"
	  },
	  gameOver: {
	    title: "GOED GEPROBEERD!",
	    time: "BESTE TIJD ",
	    retry: "Probeer het nog eens"
	  }
	};
	
	var FR = {
	  menu: {
	    title: "SAUVE LES SEMENCES !",
	    description: ["Fais glisser ton écran vers la gauche ou la droite ou appuie sur les", "flèches pour faire sauter Viktor et l’aider à chasser les oiseaux", "avant qu’ils aient mangé toutes les graines. Le jeu s’arrête quand", "4 rangées n’ont plus de graines."],
	    button: "Démarrer le jeu"
	  },
	  pauze: {
	    title: "Pause",
	    continue: "Reprend le jeu",
	    replay: "Rejouer"
	  },
	  gameOver: {
	    title: "BIEN JOUÉ !",
	    time: "Meilleur temps ",
	    retry: "Réessayer"
	  }
	};
	
	var LanguageManager = function () {
	  function LanguageManager(lang) {
	    _classCallCheck(this, LanguageManager);
	
	    this.language = lang;
	    this.text = NL;
	    if (lang == LANG_FR) this.text = FR;
	  }
	
	  _createClass(LanguageManager, [{
	    key: "getText",
	    value: function getText(key) {
	      return this.text;
	    }
	  }]);
	
	  return LanguageManager;
	}();
	
	var SwipeManager = function () {
	  function SwipeManager() {
	    _classCallCheck(this, SwipeManager);
	
	    this.isSwiping = false;
	    this.swipeDirection = 0;
	    this.swipeDuration = 0;
	    this.swipeDistance = 0;
	    this.swipeXOrigin = 0;
	    this.triggeredCallback = false;
	    this.callback = null;
	    this.scene = null;
	  }
	
	  _createClass(SwipeManager, [{
	    key: "setCallback",
	    value: function setCallback(scene, fn) {
	      this.callback = fn;
	      this.scene = scene;
	    }
	  }, {
	    key: "swipeInput",
	    value: function swipeInput(touch) {
	      if (!this.isSwiping) {
	        this.isSwiping = true;
	        this.swipeXOrigin = touch.position.x;
	      } else {
	        this.swipeDistance = touch.position.x - this.swipeXOrigin;
	        if (Math.abs(this.swipeDistance) > 50 && !this.triggeredCallback) {
	          this.swipeDirection = 1;
	          if (this.swipeDistance < 0) this.swipeDirection = -1;
	          console.log("trigger callback");
	          if (this.callback != null) this.callback(this.scene, this.swipeDirection);
	          this.triggeredCallback = true;
	        }
	      }
	    }
	  }, {
	    key: "endSwipe",
	    value: function endSwipe() {
	      if (this.isSwiping) {
	        console.log("swiping ended: " + this.swipeDistance);
	        this.isSwiping = false;
	        this.swipeDistance = 0;
	        this.swipeDirection = 0;
	        this.triggeredCallback = false;
	      }
	    }
	  }]);
	
	  return SwipeManager;
	}();
	
	var config = {
	  type: _phaser2.default.AUTO,
	  width: 960,
	  height: 540,
	  canvasStyle: "display: block; margin: 0 auto;",
	  backgroundColor: "#ffffff",
	  physics: {
	    default: 'arcade',
	    arcade: {
	      gravity: { y: 1000 }
	    }
	  },
	  scene: [Loader, Menu, Game, ScarecrowGame, InGameMenu]
	};
	
	function init(parent, pLocale) {
	  locale = pLocale;
	  config.parent = parent;
	
	  game = new _phaser2.default.Game(config);
	  return game;
	}

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/05/2017.
	 */
	var utils = __webpack_require__(25);
	
	module.exports = function () {
	  function DialogTemplate(options) {
	    _classCallCheck(this, DialogTemplate);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateElementId("dialog-");
	
	    this.title = options.title;
	    this.dialogContent = options.dialogContent;
	    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;
	
	    this.confirmText = options.confirmText;
	    this.cancelText = options.cancelText;
	    this.cancelTopRight = utils.isBoolean(options.cancelTopRight) ? options.cancelTopRight : false;
	
	    this.onConfirm = options.onConfirm;
	    this.onCancel = options.onCancel;
	
	    this.create();
	  }
	
	  _createClass(DialogTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.dialogEl.appendTo("body");
	
	        this.dialogEl.modal({
	          backdrop: this.disposable ? true : "static",
	          keyboard: this.disposable,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade'>" + "<div class='modal-dialog'>" + "<div class='modal-content clearfix'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogHeader();
	      this.renderDialogContent();
	      this.renderDialogFooter();
	
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "renderDialogHeader",
	    value: function renderDialogHeader() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length && utils.isNotNull(this.title)) {
	        var dialogHeader = "<div class='modal-header'><h4 class='dialog-title'>" + this.title + "</h4></div>";
	        dialogContentEl.append(dialogHeader);
	      }
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogBodyEl = $("<div class='modal-body'></div>");
	        dialogBodyEl.append(this.dialogContent);
	
	        dialogContentEl.append(dialogBodyEl);
	      }
	    }
	  }, {
	    key: "renderDialogFooter",
	    value: function renderDialogFooter() {
	      var that = this;
	      var dialogContentEl = that.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogFooterEl = $("<div class='modal-footer'></div>");
	
	        if (utils.isNotNull(that.confirmText)) {
	          var confirmBtn = $("<button class='btn btn-primary dialog-confirm-btn' type='button'>" + that.confirmText + "</button>");
	
	          confirmBtn.on("click", function (e) {
	            if (utils.isFunction(that.onConfirm)) {
	              that.onConfirm();
	            }
	          });
	
	          dialogFooterEl.append(confirmBtn);
	        }
	
	        if (utils.isNotNull(that.cancelText) || that.cancelTopRight === true) {
	          var classNames = "btn btn-primary dialog-cancel-btn";
	          var innerHTML = that.cancelText;
	
	          if (that.cancelTopRight) {
	            classNames = "btn btn-icon frameless cross-circle dark-grey pull-right";
	            innerHTML = "";
	          }
	
	          var cancelBtn = $("<button class='" + classNames + "' type='button'>" + innerHTML + "</button>");
	
	          cancelBtn.on("click", function () {
	            that.cancel();
	          });
	
	          if (that.cancelTopRight) {
	            that.dialogEl.find(".modal-content").prepend(cancelBtn);
	          } else {
	            dialogFooterEl.append(cancelBtn);
	          }
	        }
	
	        dialogContentEl.append(dialogFooterEl);
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (utils.isNotNull(this.dialogEl) && this.dialogEl.length && this._destroying !== true) {
	        this._destroying = true;
	
	        this.hide();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.dialogEl.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.dialogEl.modal("hide");
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.hide();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {
	      var that = this;
	
	      this.dialogEl.on("hide.bs.modal", function (e) {});
	
	      this.dialogEl.on("hidden.bs.modal", function (e) {
	        if (utils.isFunction(that.onCancel)) {
	          that.onCancel();
	        }
	        if (that._destroying) {
	          that.dialogEl.remove();
	          that._initialized = false;
	          that._destroying = false;
	        }
	      });
	
	      this.dialogEl.on("show.bs.modal", function (e) {});
	
	      this.dialogEl.on("shown.bs.modal", function (e) {});
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {}
	  }]);
	
	  return DialogTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 25/07/2017.
	 */
	var utils = __webpack_require__(25);
	
	var hasLogged = false;
	
	module.exports = function (debug) {
	  var Logger = {};
	
	  // function init(force)
	  // {
	  //   if(debug || __DEVELOPMENT__ || force)
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = console[m].bind(window.console);
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = function(...args)
	  //     {
	  //       if(!hasLogged)
	  //       {
	  //         Logger.info("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	  //         hasLogged = true;
	  //       }
	  //
	  //       args = Logger.cssify.apply(null, args);
	  //       return Logger.log.apply(null, args);
	  //     }
	  //   }
	  //   else
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = () => {};
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = () => {};
	  //   }
	  // }
	  //
	  // init();
	
	  function isDebug() {
	    return window.console && (debug || (false) || window.__PRODUCTION_LOGGING__);
	  }
	
	  function firstLogCheck() {
	    if (!hasLogged) {
	      console.log("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	      hasLogged = true;
	    }
	  }
	
	  Logger.trace = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      console.trace.apply(null, args);
	    }
	  };
	
	  Logger.debug = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      console.debug.apply(null, args);
	    }
	  };
	
	  Logger.log = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      console.log.apply(null, args);
	    }
	  };
	
	  Logger.info = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      console.info.apply(null, args);
	    }
	  };
	
	  Logger.cssLog = function () {
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    if (isDebug()) {
	      firstLogCheck();
	      args = Logger.cssify.apply(null, args);
	      console.log.apply(null, args);
	    }
	  };
	
	  Logger.warn = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      console.warn.apply(null, args);
	    }
	  };
	
	  Logger.error = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      console.error.apply(null, args);
	    }
	  };
	
	  Logger.cssify = function () {
	    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	      args[_key8] = arguments[_key8];
	    }
	
	    if (args.length > 1) {
	      var css = args[args.length - 1];
	      args.splice(args.length - 1, 1);
	
	      var cssString = "";
	
	      for (var key in css) {
	        if (css.hasOwnProperty(key)) {
	          cssString += key + ": " + css[key] + ";";
	        }
	      }
	
	      if (utils.isString(args[0])) {
	        if ((args[0].match(/%c/g) || []).length === 0) {
	          // Css applies to the whole text so just insert the css at the second (first is the text) and last place
	          args[0] = "%c" + args[0] + "%c";
	
	          args.splice(1, 0, cssString);
	          //Resets the css
	          args.push("");
	        } else if (args.length === 1) {
	          //If there's only text with no arguments, same as before, insert css at second and last place
	          args.push(cssString);
	          //Resets the css
	          args.push("");
	        } else {
	          // Determine where the css arguments need to go in the array
	          /*
	             %s - String.
	             %d - Number (integer or floating point value).
	             %i - Integer.
	             %f - Floating point value.
	             %j - JSON. Replaced with the string '[Circular]' if the argument contains circular references.
	             %o - JavaScript Object
	           */
	
	          // position BEFORE the first %c
	          var startPos = args[0].indexOf("%c");
	          // position AFTER the last %c
	          var endPos = args[0].lastIndexOf("%c") + 2;
	
	          if (startPos !== -1 && endPos !== -1 && startPos !== endPos) {
	            var leftSubString = args[0].substring(0, startPos);
	            var rightSubString = args[0].substr(endPos);
	            // Find all format occurrences
	            var firstInsert = (leftSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	            var secondInsert = (rightSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	
	            // Account for the text that's in the first position
	            args.splice(firstInsert + 1, 0, cssString);
	            //Resets the css
	            args.splice(args.length - secondInsert, 0, "");
	          }
	        }
	      }
	
	      return args;
	    }
	  };
	
	  // http://www.flatuicolorpicker.com/
	  /*
	    SUMMER SKY
	    1E8BC3
	    30, 139, 195
	   */
	  Logger.infoCss = {
	    "background-color": "#1E8BC3",
	    "color": "#ffffff"
	  };
	
	  /*
	    EUCALYPTUS
	    26A65B
	    38, 166, 91
	   */
	  Logger.successCss = {
	    "background-color": "#26A65B",
	    "color": "#ffffff"
	  };
	
	  /*
	    SANDSTORM
	    F9BF3B
	    249, 191, 59
	   */
	  Logger.warningCss = {
	    "background-color": "#F9BF3B",
	    "color": "#000000"
	  };
	
	  /*
	    FLAMINGO
	    EF4836
	    239, 72, 54
	   */
	  Logger.errorCss = {
	    "background-color": "#EF4836",
	    "color": "#ffffff"
	  };
	
	  return Logger;
	};
	
	/*
	Examples:

	logger.info("Hi");
	logger.warn("Warning");
	logger.error("Error");
	logger.cssLog("Hi %s", "Jan", logger.successCss);
	logger.cssLog("Hi %cthere Jan%c", logger.warningCss);
	logger.cssLog("Hi there %s, my name is %c%s and I am%c %d", "Jan", "Someone", 23, logger.errorCss);
	*/

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var config = {
	  serviceBaseURL: "/services",
	  stripe: {}
	};
	
	if (false) {
	  config.stripe.callbackUrl = "STRIPE_TEST_CALLBACK_URL";
	  config.stripe.publicApiKey = "STRIPE_TEST_PUBLISHABLE_KEY";
	} else {
	  config.stripe.callbackUrl = "STRIPE_LIVE_CALLBACK_URL";
	  config.stripe.publicApiKey = "STRIPE_LIVE_PUBLISHABLE_KEY";
	}
	
	module.exports = config;

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Created by jv on 14/06/2017.
	 */
	module.exports = {
	  DEFAULT_LOCALE: "nl-BE",
	
	  API_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
	  READABLE_DATE_FORMAT: "DD-MM-YYYY"
	};

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by jv on 15/05/2018.
	 */
	// https://photonstorm.github.io/phaser3-docs/loader_File.js.html#line-34
	exports.default = [
	// Misc
	{
	  key: "bg_overlay",
	  url: __webpack_require__(1631),
	  type: "image"
	}, {
	  key: "bg_cloud_green",
	  url: __webpack_require__(1630),
	  type: "image"
	},
	
	// Track background images
	{
	  key: "bg_track_clouds",
	  url: __webpack_require__(1632),
	  type: "image"
	}, {
	  key: "bg_track_grass",
	  url: __webpack_require__(1633),
	  type: "image"
	}, {
	  key: "bg_track_ground",
	  url: __webpack_require__(1634),
	  type: "image"
	}, {
	  key: "bg_track_mountain",
	  url: __webpack_require__(1635),
	  type: "image"
	}, {
	  key: "bg_track_sky",
	  url: __webpack_require__(1636),
	  type: "image"
	}];

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scenes = __webpack_require__(682);
	
	var scenes = _interopRequireWildcard(_scenes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var config = {
	  title: "carrot-game",
	  version: "0.0.1",
	  url: null,
	
	  /*
	    - `WEBGL`: Use WebGL rendering;
	    - `CANVAS`: Use 'context2D API rendering method;
	    - `AUTO`: Phaser will choose, based on device capabilities, the best rendering method to be used.
	   */
	  type: Phaser.AUTO,
	  width: 960,
	  height: 540,
	  zoom: 1,
	  resolution: 1,
	
	  // Whether to disable antialiasing or not. Great for pixel art.
	  pixelArt: false,
	  // Whether to enable canvas transparency or not.
	  transparent: false,
	
	  canvasStyle: "display: block; margin: 0 auto;",
	  backgroundColor: "#ffffff",
	
	  //physics: {
	  /*
	    - `arcade`: Phaser Arcade Physics 2;
	    - `matter`: Liam Brummitt's (@liabru) Matter.js;
	    - `impact`: ImpactJS Physics Engine.
	   */
	  /*  default: false
	  },*/
	
	  // loader: {
	  // path: "assets/games/carrot-game/"
	  // },
	
	  // scene: Object.values(scenes)
	  scene: Object.keys(scenes).map(function (key) {
	    return scenes[key];
	  })
	}; /**
	    * Created by jv on 15/05/2018.
	    */
	
	//  Import created game scenes.
	exports.default = config;

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _consumable = __webpack_require__(676);
	
	var _consumable2 = _interopRequireDefault(_consumable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Carrot = function (_Consumable) {
	  _inherits(Carrot, _Consumable);
	
	  function Carrot(scene) {
	    var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : x;
	    var position = arguments[3];
	    var doubleValue = arguments[4];
	
	    _classCallCheck(this, Carrot);
	
	    var frame = doubleValue ? "consumables/consumable_carrot-2x-shadow.png" : "consumables/consumable_carrot-shadow.png";
	    // 0 is ground
	    if (position > 0) {
	      frame = doubleValue ? "consumables/consumable_carrot-2x.png" : "consumables/consumable_carrot.png";
	    }
	
	    var _this = _possibleConstructorReturn(this, (Carrot.__proto__ || Object.getPrototypeOf(Carrot)).call(this, scene, x, y, _constants2.default.ATLAS_KEY, frame));
	
	    _this.doubleValue = doubleValue === true;
	    _this.attractTween = null;
	    return _this;
	  }
	
	  return Carrot;
	}(_consumable2.default);
	
	exports.default = Carrot;

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Created by jv on 15/05/2018.
	 */
	var Consumable = function (_Phaser$GameObjects$S) {
	  _inherits(Consumable, _Phaser$GameObjects$S);
	
	  function Consumable(scene, x, y, key, frame) {
	    var _this;
	
	    _classCallCheck(this, Consumable);
	
	    (_this = _possibleConstructorReturn(this, (Consumable.__proto__ || Object.getPrototypeOf(Consumable)).call(this, scene, x, y, key, frame)), _this).setOrigin(0, 0);
	
	    scene.children.add(_this);
	    return _this;
	  }
	
	  return Consumable;
	}(Phaser.GameObjects.Sprite);
	
	exports.default = Consumable;

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Created by jv on 15/05/2018.
	 */
	var Obstacle = function (_Phaser$GameObjects$S) {
	  _inherits(Obstacle, _Phaser$GameObjects$S);
	
	  function Obstacle(scene, x, y, key, frame) {
	    var _this;
	
	    _classCallCheck(this, Obstacle);
	
	    (_this = _possibleConstructorReturn(this, (Obstacle.__proto__ || Object.getPrototypeOf(Obstacle)).call(this, scene, x, y, key, frame)), _this).setOrigin(0, 1);
	
	    scene.children.add(_this);
	    return _this;
	  }
	
	  return Obstacle;
	}(Phaser.GameObjects.Sprite);
	
	exports.default = Obstacle;

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Created by jv on 15/05/2018.
	 */
	// export default class PowerUp extends Phaser.GameObjects.Sprite
	var PowerUp = function (_Phaser$Physics$Arcad) {
	  _inherits(PowerUp, _Phaser$Physics$Arcad);
	
	  function PowerUp(scene, x, y, options) {
	    var _this;
	
	    _classCallCheck(this, PowerUp);
	
	    (_this = _possibleConstructorReturn(this, (PowerUp.__proto__ || Object.getPrototypeOf(PowerUp)).call(this, scene, x, y, options.key, options.frame)), _this).setOrigin(0, 0);
	
	    _this.key = options.key;
	    _this.activeTexture = options.activeTexture;
	    _this.type = options.type;
	    _this.duration = options.duration;
	
	    scene.children.add(_this);
	    return _this;
	  }
	
	  return PowerUp;
	}(Phaser.Physics.Arcade.Sprite);
	
	exports.default = PowerUp;

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Rabbit = function () {
	  function Rabbit(scene, x, y) {
	    _classCallCheck(this, Rabbit);
	
	    this.scene = scene;
	
	    this.shadow = this.scene.add.sprite(x, y + 5, _constants2.default.ATLAS_KEY, "rabbit/run/shadow.png");
	    this.sprite = this.scene.physics.add.sprite(x, y, _constants2.default.ATLAS_KEY, "rabbit/run/0006.png");
	    // error correction for collision
	    // alternative: http://phaser.io/examples/v2/p2-physics/body-debug (phaser2)
	    this.sprite.body.setSize(this.sprite.width * 0.70, this.sprite.height * 0.85, true);
	    this.sprite.setBounce(0);
	    this.sprite.setCollideWorldBounds(true);
	    this.sprite.body.setImmovable(true);
	
	    this.powerUpActive = null;
	
	    this.powerUp = null;
	
	    this.alive = true;
	    this.jumping = false;
	
	    this.flashTween = null;
	  }
	
	  _createClass(Rabbit, [{
	    key: "destroy",
	    value: function destroy() {
	      this.shadow.destroy();
	      this.sprite.destroy();
	
	      if (this.powerUpActive !== null) {
	        this.powerUpActive.destroy();
	      }
	    }
	  }, {
	    key: "startRunning",
	    value: function startRunning() {
	      if (this.isTouchingGround()) {
	        this.jumping = false;
	        this.shadow.setFrame("rabbit/run/shadow.png");
	
	        if (this.powerUp !== null && this.powerUp.type === "rocket-cake") {
	          this.sprite.anims.play("rabbit-rocket-run", true);
	        } else {
	          this.sprite.anims.play("rabbit-run", true);
	        }
	      }
	    }
	  }, {
	    key: "stopRunning",
	    value: function stopRunning() {
	      this.sprite.anims.play("rabbit-idle", true);
	    }
	  }, {
	    key: "jump",
	    value: function jump() {
	      var jumpOptions = this.getJumpOptions();
	
	      this.jumping = true;
	      this.shadow.setFrame("rabbit/jump/up_shadow.png");
	      this.sprite.anims.play(jumpOptions.jumpAnimation, true);
	      this.sprite.setVelocityY(jumpOptions.velocity);
	    }
	  }, {
	    key: "fall",
	    value: function fall() {
	      var jumpOptions = this.getJumpOptions();
	
	      this.shadow.setFrame("rabbit/jump/down_shadow.png");
	      this.sprite.anims.play(jumpOptions.fallAnimation, true);
	    }
	  }, {
	    key: "isFalling",
	    value: function isFalling() {
	      return this.sprite.body.velocity.y > 0 && this.jumping;
	    }
	  }, {
	    key: "updateShadow",
	    value: function updateShadow() {
	      // maybe scale shadow (doesn't look good rn)
	    }
	  }, {
	    key: "isTouchingGround",
	    value: function isTouchingGround() {
	      // or this.sprite.body.onFloor();
	      return this.sprite.body.blocked.down;
	    }
	  }, {
	    key: "givePowerUp",
	    value: function givePowerUp(powerUp) {
	      if (powerUp) {
	        this.powerUp = powerUp;
	
	        if (this.jumping) {
	          var jumpOptions = this.getJumpOptions();
	
	          if (this.isFalling()) {
	            this.sprite.anims.play(jumpOptions.fallAnimation, true);
	          } else {
	            this.sprite.anims.play(jumpOptions.jumpAnimation, true);
	          }
	        } else {
	          this.startRunning();
	        }
	
	        if (this.powerUp.activeTexture) {
	          this.powerUpActive = this.scene.add.sprite(this.sprite.x + this.powerUp.activeTexture.offset.x, this.sprite.y + this.powerUp.activeTexture.offset.y, this.powerUp.activeTexture.key, this.powerUp.activeTexture.frame);
	          this.powerUpActive.setDepth(89);
	        }
	
	        var that = this;
	
	        this.scene.time.delayedCall(this.powerUp.duration - 5000, function () {
	          var tween = that.scene.tweens.addCounter({
	            from: 0,
	            to: 100,
	            loop: 10,
	            duration: 500,
	            onUpdate: function onUpdate() {
	              if (that.powerUp !== null) {
	                if (that.powerUpActive !== null) {
	                  that.powerUpActive.setVisible(tween.getValue() > 50);
	                } else {
	                  that.sprite.setVisible(tween.getValue() > 50);
	                }
	              }
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: "removePowerUp",
	    value: function removePowerUp() {
	      if (this.powerUp) {
	        if (this.powerUpActive !== null) {
	          this.powerUpActive.destroy();
	          this.powerUpActive = null;
	        }
	
	        this.powerUp = null;
	      }
	    }
	  }, {
	    key: "attractPowerUp",
	    value: function attractPowerUp() {
	      if (this.powerUp !== null && this.powerUp.activeTexture) {
	        this.powerUpActive.setPosition(this.sprite.x + this.powerUp.activeTexture.offset.x, this.sprite.y + this.powerUp.activeTexture.offset.y);
	      }
	    }
	  }, {
	    key: "hasRocketCake",
	    value: function hasRocketCake() {
	      return typeof this.powerUp !== "undefined" && this.powerUp !== null && this.powerUp.type === "rocket-cake";
	    }
	  }, {
	    key: "flash",
	    value: function flash() {
	      var startColor = Phaser.Display.Color.HexStringToColor("#ff0000"),
	          endColor = Phaser.Display.Color.HexStringToColor("#ffffff");
	
	      if (this.flashTween !== null && this.flashTween.isPlaying()) {
	        // this.flashTween.stop();
	        return;
	      }
	
	      var that = this;
	
	      this.flashTween = this.scene.tweens.addCounter({
	        from: 0,
	        to: 100,
	        loop: 1,
	        duration: 200,
	        onUpdate: function onUpdate() {
	          that.sprite.tint = Phaser.Display.Color.ObjectToColor(Phaser.Display.Color.Interpolate.ColorWithColor(startColor, endColor, 100, that.flashTween.getValue())).color;
	        },
	        onComplete: function onComplete() {}
	      });
	    }
	  }, {
	    key: "getJumpOptions",
	    value: function getJumpOptions() {
	      if (this.powerUp !== null) {
	        /*if(this.powerUp.type === "springball")
	        {
	          return { jumpAnimation: "rabbit-springball-jumping", fallAnimation: "rabbit-springball-falling", velocity: -350 };
	        }
	        else */if (this.powerUp.type === "rocket-cake") {
	          return { jumpAnimation: "rabbit-rocket-jumping", fallAnimation: "rabbit-rocket-falling", velocity: -525 };
	        }
	      }
	
	      return { jumpAnimation: "rabbit-jumping", fallAnimation: "rabbit-falling", velocity: -525 };
	    }
	  }]);
	
	  return Rabbit;
	}();
	
	exports.default = Rabbit;

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _text = __webpack_require__(369);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 25/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Text = void 0;
	
	var GameOver = function (_Phaser$Scene) {
	  _inherits(GameOver, _Phaser$Scene);
	
	  function GameOver() {
	    _classCallCheck(this, GameOver);
	
	    return _possibleConstructorReturn(this, (GameOver.__proto__ || Object.getPrototypeOf(GameOver)).call(this, {
	      key: "GameOver"
	    }));
	  }
	
	  _createClass(GameOver, [{
	    key: "init",
	    value: function init(_ref) {
	      var gameScene = _ref.gameScene;
	
	      Text = (0, _text2.default)();
	
	      this.gameScene = gameScene;
	      this.gameScene.events.off("game-end").on("game-end", function () {
	        this.setHighScore();
	        this.setVisible(true);
	      }, this);
	
	      this.scene.setVisible(false);
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      var _this2 = this;
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.backdrop = this.add.image(0, 0, "bg_overlay").setOrigin(0, 0);
	
	      this.add.text(gameWidth / 2, gameHeight / 4, Text.gameOver.title, { fontFamily: "RabbitOnTheMoon", fontSize: 48, fontWeight: "normal", fill: "#FFFFFF" }).setOrigin(0.5);
	
	      this.highScoreLabel = this.add.text(gameWidth / 2, gameHeight / 2, "", { fontFamily: "RabbitOnTheMoon", fontSize: 36, fontWeight: "normal", fill: "#FFFFFF" }).setOrigin(0.5).setPadding({ right: 10 });
	      this.highScoreLabelImage = this.add.image(this.highScoreLabel.x + this.highScoreLabel.width + 5, this.highScoreLabel.y - 10, _constants2.default.ATLAS_KEY, "consumables/consumable_carrot.png").setOrigin(0, 0.5);
	
	      var buttonImageHeight = this.scene.systems.game.textures.getFrame(_constants2.default.ATLAS_KEY, "misc/image_button.png").realHeight;
	      var buttonImage = this.add.image(gameWidth / 2, gameHeight - buttonImageHeight * 1.5, _constants2.default.ATLAS_KEY, "misc/image_button.png").setOrigin(0.5, 1);
	      var restartIconWidth = this.scene.systems.game.textures.getFrame(_constants2.default.ATLAS_KEY, "misc/icon_restart.png").realWidth;
	      var startButtonText = this.add.text(buttonImage.x + restartIconWidth, buttonImage.y - buttonImage.height / 2, Text.gameOver.replayBtn, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 18, fill: "#ffffff" }).setOrigin(0.5).setPadding({ left: 15 });
	      this.add.image(startButtonText.x - startButtonText.width / 2, startButtonText.y, _constants2.default.ATLAS_KEY, "misc/icon_restart.png").setOrigin(1, 0.5);
	
	      this.replayBtnZone = this.add.zone(buttonImage.x - buttonImage.width * buttonImage.originX - 5, buttonImage.y - buttonImage.height * buttonImage.originY - 5, buttonImage.width + 10, buttonImage.height + 10).setName("replay-button").once("pointerup", function () {
	        _this2.input.mouse.target.style.cursor = "";
	        _this2.gameScene.restart();
	      }, this).on("pointerover", function (e) {
	        _this2.input.mouse.target.style.cursor = "pointer";
	      }).on("pointerout", function (e) {
	        _this2.input.mouse.target.style.cursor = "";
	      });
	    }
	  }, {
	    key: "setHighScore",
	    value: function setHighScore() {
	      var highScoreText = Text.gameOver.highScore + this.gameScene.highScore;
	      this.highScoreLabel.setText(highScoreText);
	      this.highScoreLabelImage.x = this.highScoreLabel.x + this.highScoreLabel.width / 2;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(flag) {
	      if (flag) {
	        this.replayBtnZone.setInteractive();
	      } else {
	        this.replayBtnZone.removeInteractive();
	      }
	
	      this.scene.setVisible(flag);
	    }
	  }]);
	
	  return GameOver;
	}(Phaser.Scene);
	
	exports.default = GameOver;

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Game = function (_Phaser$Scene) {
	  _inherits(Game, _Phaser$Scene);
	
	  function Game() {
	    _classCallCheck(this, Game);
	
	    /**
	     *  Keep the last high score registered.
	     */
	    var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this, { key: "Game" }));
	
	    _this.highScore = 0;
	    return _this;
	  }
	
	  _createClass(Game, [{
	    key: "init",
	    value: function init() {
	      // https://github.com/photonstorm/phaser/issues/3185
	      this.scene.launch("Track").launch("Menu", { type: "pause-menu" }).launch("Scoreboard", { gameScene: this }).launch("GameOver", { gameScene: this });
	
	      this.points = 0;
	      this.paused = false;
	      this.debug = _constants2.default.DEBUG;
	
	      this.speedIncreaseTimer = null;
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.track = this.scene.get("Track");
	
	      this.setSceneOrder();
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      var grassHeight = this.scene.systems.game.textures.get("bg_track_grass").getSourceImage().height;
	      var pathHeight = this.scene.systems.game.textures.get("bg_track_ground").getSourceImage().height;
	
	      this.sky = this.add.tileSprite(0, 0, gameWidth, gameHeight, "bg_track_sky").setOrigin(0, 0);
	      this.clouds = this.add.tileSprite(0, 0, gameWidth, this.scene.systems.game.textures.get("bg_track_clouds").getSourceImage().height, "bg_track_clouds").setOrigin(0, 0);
	      this.mountains = this.add.tileSprite(0, gameHeight - pathHeight - 185, gameWidth, this.scene.systems.game.textures.get("bg_track_mountain").getSourceImage().height, "bg_track_mountain").setOrigin(0, 0);
	      this.grass = this.add.tileSprite(0, gameHeight - pathHeight - grassHeight + 1, gameWidth, grassHeight, "bg_track_grass").setOrigin(0, 0);
	      this.path = this.add.tileSprite(0, gameHeight - pathHeight, gameWidth, pathHeight, "bg_track_ground").setOrigin(0, 0);
	
	      // Set up input
	      this.setUpInput();
	
	      this.track.events.off("carrot-taken").on("carrot-taken", this.carrotTaken, this).off("rabbit-collided").on("rabbit-collided", this.rabbitCollided, this);
	
	      // Speed increase loop (start increasing speed every 10 seconds AFTER 30 seconds)
	      this.setUpSpeedIncreaseTimer();
	
	      if (this.debug) {
	        this._debugText = this.add.text(100, 20);
	        this._debugText.setShadow(1, 1, "#000000", true, false);
	      }
	    }
	  }, {
	    key: "setSceneOrder",
	    value: function setSceneOrder() {
	      this.scene.moveAbove("Game", "Scoreboard");
	      this.scene.moveAbove("Scoreboard", "Track");
	      this.scene.moveAbove("Track", "Menu");
	      this.scene.moveAbove("Menu", "GameOver");
	    }
	  }, {
	    key: "setUpInput",
	    value: function setUpInput() {
	      var _this2 = this;
	
	      this.cursors = this.input.keyboard.addKeys({
	        upKey: Phaser.Input.Keyboard.KeyCodes.UP
	      });
	      this.spaceKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
	
	      this.input.off("pointerdown").on("pointerdown", function (e) {
	        if (!_this2.paused) {
	          _this2.clickJump = true;
	          // this.track.updateInput({ cursors: this.cursors, spaceKey: this.spaceKey, pointerDown: true });
	        }
	      }, this);
	    }
	  }, {
	    key: "setUpSpeedIncreaseTimer",
	    value: function setUpSpeedIncreaseTimer() {
	      var _this3 = this;
	
	      this.speedIncreaseTimer = this.time.delayedCall(30000, function () {
	        // this.track.trackSpeed += 0.5;
	        _this3.track.trackSpeed += 0.03;
	
	        _this3.speedIncreaseTimer = _this3.time.addEvent({ delay: 10000, callback: function callback() {
	            // this.track.trackSpeed += 0.5;
	            _this3.track.trackSpeed += 0.03;
	          }, callbackScope: _this3, loop: true });
	      });
	    }
	  }, {
	    key: "update",
	    value: function update(time, delta) {
	      this._updateDebugText();
	
	      if (this.track.rabbit.alive && !this.paused) {
	        this.updateBackground(time, delta);
	        this.track.updateInput({ cursors: this.cursors, spaceKey: this.spaceKey, pointerDown: this.clickJump });
	        this.clickJump = false;
	        this.updateLogic(time);
	      }
	    }
	  }, {
	    key: "updateBackground",
	    value: function updateBackground(time, delta) {
	      // console.log(delta);
	
	      var speed = delta * this.track.trackSpeed;
	
	      // this.sky.tilePositionX += this.track.trackSpeed / 15;
	      // this.clouds.tilePositionX += this.track.trackSpeed / 8;
	      // this.mountains.tilePositionX += this.track.trackSpeed / 6;
	      // this.grass.tilePositionX += this.track.trackSpeed / 4;
	      // this.path.tilePositionX += this.track.trackSpeed;
	
	      // console.log(speed);
	
	      this.sky.tilePositionX += speed / 15;
	      this.clouds.tilePositionX += speed / 8;
	      this.mountains.tilePositionX += speed / 6;
	      this.grass.tilePositionX += speed / 4;
	      this.path.tilePositionX += speed;
	    }
	  }, {
	    key: "updateLogic",
	    value: function updateLogic(time) {
	      if (!this.track.rabbit.alive) {
	        this.endGame();
	      }
	
	      if (this.track.rabbit.powerUp !== null) {
	        this.track.rabbit.attractPowerUp();
	      }
	    }
	  }, {
	    key: "endGame",
	    value: function endGame() {
	      var _this4 = this;
	
	      //  Update the high score.
	      this.highScore = Math.max(this.points, this.highScore);
	
	      this.scene.get("Scoreboard").setHelpButtonInteractive(false);
	
	      this.pause();
	
	      this.time.delayedCall(1000, function () {
	        _this4.track.clearTrack();
	        _this4.events.emit("game-end");
	      });
	    }
	  }, {
	    key: "restart",
	    value: function restart() {
	      this.scene.stop("Track").stop("Scoreboard").stop("Menu").stop("GameOver").start("Game");
	    }
	  }, {
	    key: "resume",
	    value: function resume() {
	      this.paused = false;
	
	      if (this.speedIncreaseTimer !== null) {
	        this.speedIncreaseTimer.paused = false;
	      }
	
	      this.scene.get("Track").paused = false;
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.paused = true;
	
	      if (this.speedIncreaseTimer !== null) {
	        this.speedIncreaseTimer.paused = true;
	      }
	
	      this.scene.get("Track").paused = true;
	    }
	  }, {
	    key: "togglePause",
	    value: function togglePause() {
	      if (this.paused) {
	        this.resume();
	      } else {
	        this.pause();
	      }
	    }
	  }, {
	    key: "carrotTaken",
	    value: function carrotTaken(carrot) {
	      this.points += carrot.doubleValue ? 2 : 1;
	      this.events.emit("points-updated", this.points);
	    }
	  }, {
	    key: "rabbitCollided",
	    value: function rabbitCollided() {
	      this.endGame();
	    }
	  }, {
	    key: "_updateDebugText",
	    value: function _updateDebugText() {
	      if (this.debug) {
	        var textContent = [];
	
	        textContent.push("HighScore: " + this.highScore);
	        textContent.push("Alive: " + this.track.rabbit.alive);
	        textContent.push("Missed (c | o | p): " + this.track.carrotsMissed + " | " + this.track.obstaclesAvoided + " | " + this.track.powerUpsMissed);
	        var powerUp = "/";
	        if (typeof this.track.rabbit.powerUp !== "undefined" && this.track.rabbit.powerUp !== null) {
	          powerUp = this.track.rabbit.powerUp.type;
	          if (this.track.powerUpTimer !== null) {
	            var timeRemaining = Math.round(this.track.powerUpTimer.delay / 1000) - Math.round(this.track.powerUpTimer.getElapsedSeconds());
	            powerUp += " (" + timeRemaining + "s)";
	          }
	        }
	        textContent.push("PowerUp: " + powerUp);
	        textContent.push("Trackspeed: " + this.track.trackSpeed);
	        var timeTillNextSpeedIncrease = "/";
	        if (typeof this.speedIncreaseTimer !== "undefined" && this.speedIncreaseTimer !== null) {
	          timeTillNextSpeedIncrease = Math.round(this.speedIncreaseTimer.delay / 1000) - Math.round(this.speedIncreaseTimer.getElapsedSeconds());
	        }
	        textContent.push("Time until next speed increase: " + timeTillNextSpeedIncrease + "s");
	
	        var timeTillCarrotSpawn = "/";
	        var timeTillObstacleSpawn = "/";
	        var timeTillPowerUpSpawn = "/";
	
	        if (typeof this.track.carrotSpawnTimer !== "undefined" && this.track.carrotSpawnTimer !== null) {
	          timeTillCarrotSpawn = Math.round(this.track.carrotSpawnTimer.delay - this.track.carrotSpawnTimer.getElapsed());
	        }
	        if (typeof this.track.obstacleSpawnTimer !== "undefined" && this.track.obstacleSpawnTimer !== null) {
	          timeTillObstacleSpawn = Math.round(this.track.obstacleSpawnTimer.delay - this.track.obstacleSpawnTimer.getElapsed());
	        }
	        if (typeof this.track.powerUpSpawnTimer !== "undefined" && this.track.powerUpSpawnTimer !== null) {
	          timeTillPowerUpSpawn = Math.round(this.track.powerUpSpawnTimer.delay / 1000) - Math.round(this.track.powerUpSpawnTimer.getElapsedSeconds());
	        }
	
	        textContent.push("Next spawn (c | o | p): " + timeTillCarrotSpawn + "ms | " + timeTillObstacleSpawn + "ms | " + timeTillPowerUpSpawn + "s");
	
	        this._debugText.setText(textContent);
	      }
	    }
	  }]);
	
	  return Game;
	}(Phaser.Scene);
	
	exports.default = Game;

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loader = __webpack_require__(683);
	
	Object.defineProperty(exports, "Loader", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loader).default;
	  }
	});
	
	var _menu = __webpack_require__(684);
	
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_menu).default;
	  }
	});
	
	var _game = __webpack_require__(681);
	
	Object.defineProperty(exports, "Game", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_game).default;
	  }
	});
	
	var _scoreboard = __webpack_require__(685);
	
	Object.defineProperty(exports, "Scoreboard", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scoreboard).default;
	  }
	});
	
	var _gameOver = __webpack_require__(680);
	
	Object.defineProperty(exports, "GameOver", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gameOver).default;
	  }
	});
	
	var _track = __webpack_require__(686);
	
	Object.defineProperty(exports, "Track", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_track).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _assets = __webpack_require__(673);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var carrotGameAtlas = __webpack_require__(1629);
	var carrotGameAtlasJson = __webpack_require__(984);
	
	var Loader = function (_Phaser$Scene) {
	  _inherits(Loader, _Phaser$Scene);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).call(this, {
	      key: "Loader",
	      pack: { files: _assets2.default }
	    }));
	  }
	
	  _createClass(Loader, [{
	    key: "init",
	    value: function init() {
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.add.text(gameWidth / 2, gameHeight / 2, "Loading...", { fontFamily: "RabbitOnTheMoon", fontSize: 18, fontWeight: "normal", fill: "#000000" }).setOrigin(0.5);
	    }
	  }, {
	    key: "preload",
	    value: function preload() {
	      this.load.atlas(_constants2.default.ATLAS_KEY, carrotGameAtlas, carrotGameAtlasJson);
	      this.loadFonts();
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.createAnimations();
	      this.scene.start("Menu");
	    }
	  }, {
	    key: "loadFonts",
	    value: function loadFonts() {
	      this.preloadFont("RabbitOnTheMoon");
	      this.preloadFont("AbadiMTPro-CondExtraBold");
	    }
	  }, {
	    key: "preloadFont",
	    value: function preloadFont(font) {
	      var text = this.add.text(0, 0, "text", { fontFamily: font, fontSize: 1, fill: "#FFFFFF" });
	      text.visible = false;
	    }
	  }, {
	    key: "createAnimations",
	    value: function createAnimations() {
	      // Rabbit run animation
	      var runFrameNames = this.anims.generateFrameNames(_constants2.default.ATLAS_KEY, {
	        start: 1, end: 6, zeroPad: 4,
	        prefix: "rabbit/run/", suffix: ".png"
	      });
	      this.anims.create({ key: "rabbit-run", frames: runFrameNames, frameRate: 10, repeat: -1 });
	
	      // Rabbit rocket run animation
	      var runFrameNames = this.anims.generateFrameNames(_constants2.default.ATLAS_KEY, {
	        start: 1, end: 6, zeroPad: 4,
	        prefix: "rabbit/run/rocket-cake/", suffix: ".png"
	      });
	      this.anims.create({ key: "rabbit-rocket-run", frames: runFrameNames, frameRate: 10, repeat: -1 });
	
	      // Rabbit idle animation
	      this.anims.create({
	        key: "rabbit-idle",
	        frames: [{ key: _constants2.default.ATLAS_KEY, frame: "rabbit/run/0006.png" }],
	        frameRate: 20
	      });
	
	      // Rabbit jumping animation
	      this.anims.create({
	        key: "rabbit-jumping",
	        frames: [{ key: _constants2.default.ATLAS_KEY, frame: "rabbit/jump/up.png" }],
	        frameRate: 20
	      });
	
	      // Rabbit rocket jumping animation
	      this.anims.create({
	        key: "rabbit-rocket-jumping",
	        frames: [{ key: _constants2.default.ATLAS_KEY, frame: "rabbit/jump/rocket-cake/up.png" }],
	        frameRate: 20
	      });
	
	      // Rabbit falling animation
	      this.anims.create({
	        key: "rabbit-falling",
	        frames: [{ key: _constants2.default.ATLAS_KEY, frame: "rabbit/jump/down.png" }],
	        frameRate: 20
	      });
	
	      // Rabbit rocket falling animation
	      this.anims.create({
	        key: "rabbit-rocket-falling",
	        frames: [{ key: _constants2.default.ATLAS_KEY, frame: "rabbit/jump/rocket-cake/down.png" }],
	        frameRate: 20
	      });
	    }
	  }]);
	
	  return Loader;
	}(Phaser.Scene);
	
	exports.default = Loader;

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _text = __webpack_require__(369);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Text = void 0;
	
	var MAIN_MENU = "main-menu";
	var PAUSE_MENU = "pause-menu";
	
	var Menu = function (_Phaser$Scene) {
	  _inherits(Menu, _Phaser$Scene);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, { key: "Menu" }));
	
	    _this.type = MAIN_MENU;;
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: "init",
	    value: function init(_ref) {
	      var type = _ref.type;
	
	      Text = (0, _text2.default)();
	
	      if (type === MAIN_MENU || type === PAUSE_MENU) {
	        this.type = type;
	      }
	
	      if (typeof this.type === "undefined" || this.type === null) {
	        this.type = MAIN_MENU;
	      }
	
	      if (this.type === PAUSE_MENU) {
	        this.scene.setVisible(false);
	      }
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.createBackground();
	
	      this.createText();
	
	      this.createPowerUpsOverview();
	
	      this.createButton();
	    }
	  }, {
	    key: "createBackground",
	    value: function createBackground() {
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      if (this.type === MAIN_MENU) {
	        var grassHeight = this.scene.systems.game.textures.get("bg_track_grass").getSourceImage().height;
	        var pathHeight = this.scene.systems.game.textures.get("bg_track_ground").getSourceImage().height;
	
	        this.add.tileSprite(0, 0, gameWidth, gameHeight, "bg_track_sky").setOrigin(0, 0);
	        this.add.tileSprite(0, 0, gameWidth, this.scene.systems.game.textures.get("bg_track_clouds").getSourceImage().height, "bg_track_clouds").setOrigin(0, 0);
	        this.add.tileSprite(0, gameHeight - pathHeight - 185, gameWidth, this.scene.systems.game.textures.get("bg_track_mountain").getSourceImage().height, "bg_track_mountain").setOrigin(0, 0);
	        this.add.tileSprite(0, gameHeight - pathHeight - grassHeight + 1, gameWidth, grassHeight, "bg_track_grass").setOrigin(0, 0);
	        this.add.tileSprite(0, gameHeight - pathHeight, gameWidth, pathHeight, "bg_track_ground").setOrigin(0, 0);
	      }
	
	      this.backdrop = this.add.image(0, 0, "bg_overlay").setOrigin(0, 0);
	
	      var cloud = this.add.image(0, 0, "bg_cloud_green").setOrigin(0);
	      cloud.setDisplaySize(gameWidth, gameHeight);
	      this.paint = this.add.image(gameWidth / 2, gameHeight / 2 + 30, _constants2.default.ATLAS_KEY, "misc/image_paint_light-green.png").setOrigin(0.5);
	      // cloud.createBitmapMask();
	      // paint.setMask(cloud);
	    }
	  }, {
	    key: "createText",
	    value: function createText() {
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      var title = this.add.text(gameWidth / 2, 25, Text.menu.title, { fontFamily: "RabbitOnTheMoon", fontSize: 28, fontWeight: "normal", fill: "#FFFFFF" }).setOrigin(0.5, 0).setPadding(15);
	
	      var controlsImage = this.add.image(0, 0, _constants2.default.ATLAS_KEY, "misc/image_controls.png").setOrigin(0, 1);
	
	      var controlsText = this.add.text(gameWidth / 2 - controlsImage.width / 2, title.height + 45, Text.menu.controlsDescription, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 18, fontWeight: "normal", fill: "#FFFFFF" }).setPadding({ right: 20 }).setOrigin(0.5, 0);
	
	      controlsImage.x = controlsText.x + controlsText.width / 2 + 15;
	      controlsImage.y = controlsText.y + controlsText.height + 5;
	    }
	  }, {
	    key: "createPowerUpsOverview",
	    value: function createPowerUpsOverview() {
	      // Shield
	      this.createPowerUpOverview(Text.menu.powerUps.shield.title, "misc/image_menu_shield.png", Text.menu.powerUps.shield.description, 1);
	
	      // Springball
	      // this.createPowerUpOverview(Text.menu.powerUps.springball.title, "misc/image_menu_springball.png", Text.menu.powerUps.springball.description, 2);
	
	      // Rocket cake
	      this.createPowerUpOverview(Text.menu.powerUps.rocketCake.title, "misc/image_menu_rocket-cake.png", Text.menu.powerUps.rocketCake.description, 2);
	
	      // Magnet
	      this.createPowerUpOverview(Text.menu.powerUps.magnet.title, "misc/image_menu_magnet.png", Text.menu.powerUps.magnet.description, 3);
	    }
	  }, {
	    key: "createPowerUpOverview",
	    value: function createPowerUpOverview(titleContent, imageFrame, descriptionContent, position) {
	      var powersUpsOverviewWidth = this.paint.width * 3 / 5;
	      var textColor = "#946331";
	
	      // 1 --> -1.5 // 2 --> -0.5 // 3 --> +0.5 // 4 --> +1.5
	      // position -= 2.5;
	
	      // 1 --> -1
	      // 2 --> 0
	      // 3 --> 1
	      position -= 2;
	
	      var imageX = this.paint.x + powersUpsOverviewWidth / 3 * position;
	      var image = this.add.image(imageX, this.paint.y, _constants2.default.ATLAS_KEY, imageFrame).setOrigin(0.5);
	      this.add.text(image.x, image.y - image.height / 2 - 15, titleContent, { fontFamily: "RabbitOnTheMoon", fontSize: 18, fontWeight: "normal", fill: textColor }).setOrigin(0.5, 1);
	      this.add.text(image.x, image.y + image.height / 2 + 15, descriptionContent, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 16, fontWeight: "normal", fill: textColor, align: "center" }).setOrigin(0.5, 0);
	    }
	  }, {
	    key: "createButton",
	    value: function createButton() {
	      var _this2 = this;
	
	      var CENTER = {
	        x: this.cameras.main.width / 2,
	        y: this.cameras.main.height / 2
	      };
	
	      var buttonImage = this.add.image(CENTER.x, this.paint.y + this.paint.height / 2 + 15, _constants2.default.ATLAS_KEY, "misc/image_button.png").setOrigin(0.5, 0);
	      var playIconWidth = this.scene.systems.game.textures.getFrame(_constants2.default.ATLAS_KEY, "misc/icon_play.png").realWidth;
	      var btnText = this.type === PAUSE_MENU ? Text.menu.resumeBtn : Text.menu.playBtn;
	      var startButtonText = this.add.text(CENTER.x + playIconWidth, buttonImage.y + buttonImage.height / 2, btnText, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 21, fill: "#ffffff" }).setOrigin(0.5).setPadding({ left: 15 });
	      var playIcon = this.add.image(startButtonText.x - startButtonText.width / 2, startButtonText.y, _constants2.default.ATLAS_KEY, "misc/icon_play.png").setOrigin(1, 0.5);
	
	      //  Handle the click or tap of the button using an input zone slightly
	      //  bigger than the text object.
	      this.playBtnZone = this.add.zone(buttonImage.x - buttonImage.width * buttonImage.originX - 5, buttonImage.y - buttonImage.height * buttonImage.originY - 5, buttonImage.width + 10, buttonImage.height + 10).setName("play-button").on("pointerover", function (e) {
	        _this2.input.mouse.target.style.cursor = "pointer";
	      }).on("pointerout", function (e) {
	        _this2.input.mouse.target.style.cursor = "";
	      });
	
	      this.setPlayBtnEvent();
	
	      if (this.type === MAIN_MENU) {
	        this.setInteractive();
	      }
	    }
	  }, {
	    key: "setPlayBtnEvent",
	    value: function setPlayBtnEvent() {
	      var _this3 = this;
	
	      this.playBtnZone.once("pointerup", function () {
	        _this3.input.mouse.target.style.cursor = "";
	
	        if (_this3.type === PAUSE_MENU) {
	          _this3.events.emit("resume-btn-clicked");
	          _this3.setPlayBtnEvent();
	        } else {
	          _this3.scene.start("Game");
	        }
	      });
	    }
	  }, {
	    key: "setInteractive",
	    value: function setInteractive(flag) {
	      if (flag !== false) {
	        if (this.playBtnZone) {
	          this.playBtnZone.setInteractive();
	        }
	      } else {
	        if (this.playBtnZone) {
	          this.playBtnZone.removeInteractive();
	        }
	      }
	
	      return this;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(flag) {
	      if (flag) {
	        this.setInteractive(flag !== false);
	      } else {
	        this.setInteractive(flag !== false);
	      }
	
	      this.scene.setVisible(flag);
	
	      return this;
	    }
	  }]);
	
	  return Menu;
	}(Phaser.Scene);
	
	exports.default = Menu;

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Scoreboard = function (_Phaser$Scene) {
	  _inherits(Scoreboard, _Phaser$Scene);
	
	  function Scoreboard() {
	    _classCallCheck(this, Scoreboard);
	
	    return _possibleConstructorReturn(this, (Scoreboard.__proto__ || Object.getPrototypeOf(Scoreboard)).call(this, {
	      key: "Scoreboard"
	    }));
	  }
	
	  _createClass(Scoreboard, [{
	    key: "init",
	    value: function init(_ref) {
	      var _this2 = this;
	
	      var gameScene = _ref.gameScene;
	
	      this.gameScene = gameScene;
	      this.gameScene.events.off("points-updated").on("points-updated", function (points) {
	        return _this2.setScore(points);
	      });
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      var _this3 = this;
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	      var spacing = 15;
	
	      this.helpImageBtn = this.add.image(spacing, spacing, _constants2.default.ATLAS_KEY, "misc/image_info.png").setOrigin(0, 0);
	      this.helpBtnZone = this.add.zone(this.helpImageBtn.x - this.helpImageBtn.width * this.helpImageBtn.originX - 5, this.helpImageBtn.y - this.helpImageBtn.height * this.helpImageBtn.originY - 5, this.helpImageBtn.width + 10, this.helpImageBtn.height + 10).setName("help-button").setInteractive().on("pointerup", function () {
	        _this3.input.mouse.target.style.cursor = "";
	        _this3.gameScene.togglePause();
	        _this3.showHelpScreen();
	      }).on("pointerover", function (e) {
	        _this3.input.mouse.target.style.cursor = "pointer";
	      }).on("pointerout", function (e) {
	        _this3.input.mouse.target.style.cursor = "";
	      });
	
	      this.scoreLabelImage = this.add.image(gameWidth - spacing, spacing, _constants2.default.ATLAS_KEY, "consumables/consumable_carrot.png").setOrigin(1, 0);
	      this.scoreLabel = this.add.text(this.scoreLabelImage.x - this.scoreLabelImage.width, spacing, "0x", { fontFamily: "RabbitOnTheMoon", fontSize: 48, fontWeight: "normal", fill: "#D4781E" }).setOrigin(1, 0).setPadding({ top: 10, right: 5 });
	    }
	  }, {
	    key: "setHelpButtonInteractive",
	    value: function setHelpButtonInteractive(flag) {
	      if (flag !== false) {
	        if (this.helpBtnZone) {
	          this.helpBtnZone.setInteractive();
	        }
	      } else {
	        if (this.helpBtnZone) {
	          this.helpBtnZone.removeInteractive();
	        }
	      }
	    }
	  }, {
	    key: "setScore",
	    value: function setScore(points) {
	      this.scoreLabel.setText(points + "x");
	    }
	  }, {
	    key: "showHelpScreen",
	    value: function showHelpScreen() {
	      this.helpBtnZone.removeInteractive();
	
	      var menuScene = this.scene.get("Menu");
	      menuScene.setVisible(true);
	      menuScene.events.once("resume-btn-clicked", function () {
	        this.helpBtnZone.setInteractive();
	        menuScene.setInteractive(false).scene.setVisible(false);
	        this.gameScene.togglePause();
	      }, this);
	    }
	  }]);
	
	  return Scoreboard;
	}(Phaser.Scene);
	
	exports.default = Scoreboard;

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(89);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _rabbit = __webpack_require__(679);
	
	var _rabbit2 = _interopRequireDefault(_rabbit);
	
	var _carrot2 = __webpack_require__(675);
	
	var _carrot3 = _interopRequireDefault(_carrot2);
	
	var _obstacle2 = __webpack_require__(677);
	
	var _obstacle3 = _interopRequireDefault(_obstacle2);
	
	var _powerup = __webpack_require__(678);
	
	var _powerup2 = _interopRequireDefault(_powerup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Track = function (_Phaser$Scene) {
	  _inherits(Track, _Phaser$Scene);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, {
	      key: "Track",
	      physics: {
	        default: "arcade",
	        arcade: {
	          // springbal: 300
	          gravity: { y: 650 },
	          debug: _constants2.default.DEBUG
	        }
	      }
	    }));
	
	    _this.trackSpeed = 1;
	    _this.carrotsMissed = 0;
	    _this.obstaclesAvoided = 0;
	    _this.powerUpsMissed = 0;
	    _this._paused = false;
	
	    _this.minCarrotSpacing = 200;
	    _this.minObstacleSpacing = 200;
	
	    _this.rabbit = null;
	
	    _this.carrots = null;
	    _this.obstacles = null;
	    _this.powerUps = null;
	    return _this;
	  }
	
	  _createClass(Track, [{
	    key: "init",
	    value: function init() {
	      this.paused = false;
	
	      // this.trackSpeed = 5.5;
	      this.trackSpeed = 0.33;
	
	      this.carrotSpawnRate = 1.33 * 1000;
	      this.obstacleSpawnRate = { min: 2.75 * 1000, max: 4 * 1000 };
	      this.powerUpSpawnRate = { min: 35 * 1000, max: 55 * 1000 };
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.carrotsMissed = 0;
	      this.obstaclesAvoided = 0;
	      this.powerUpsMissed = 0;
	
	      this.rabbitPosition = {
	        x: 200,
	        y: gameHeight - 130
	      };
	
	      this.spawnLocation = {
	        x: gameWidth + 300,
	        y: gameHeight - 110
	      };
	
	      this.despawnLocation = {
	        x: -300
	      };
	
	      this.spawnAllowed = true;
	
	      this.obstacleSpawnTimer = null;
	      this.carrotSpawnTimer = null;
	      this.powerUpSpawnTimer = null;
	      this.powerUpTimer = null;
	
	      this.physics.world.setBounds(0, -150, gameWidth, gameHeight + 20);
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.createRabbit(this.rabbitPosition.x, this.rabbitPosition.y);
	      this.rabbit.startRunning();
	
	      this.carrots = this.physics.add.group();
	      this.obstacles = this.physics.add.group();
	      this.powerUps = this.physics.add.group();
	
	      // https://photonstorm.github.io/phaser3-docs/physics_arcade_World.js.html#line-1348
	      this.physics.add.overlap(this.rabbit.sprite, this.carrots, this.collectCarrot, null, this);
	      this.physics.add.overlap(this.rabbit.sprite, this.powerUps, this.collectPowerUp, null, this);
	      this.physics.add.collider(this.rabbit.sprite, this.obstacles, this.obstacleHit, null, this);
	
	      this.createDespawnZone();
	      this.createAutoCollectZone();
	
	      this.startObjectSpawning();
	    }
	  }, {
	    key: "createDespawnZone",
	    value: function createDespawnZone() {
	      var _this2 = this;
	
	      this.despawnZone = this.add.zone(this.despawnLocation.x, 0, 1, this.sys.game.config.height);
	      this.physics.world.enable(this.despawnZone);
	      this.despawnZone.body.allowGravity = false;
	      this.despawnZone.body.setImmovable(true);
	      this.physics.add.overlap(this.despawnZone, this.carrots, function (zone, carrot) {
	        _this2.removeOutOfBoundObject(zone, carrot);_this2.carrotsMissed++;
	      }, null, this);
	      this.physics.add.overlap(this.despawnZone, this.obstacles, function (zone, obstacle) {
	        _this2.removeOutOfBoundObject(zone, obstacle);_this2.obstaclesAvoided++;
	      }, null, this);
	      this.physics.add.overlap(this.despawnZone, this.powerUps, function (zone, powerUp) {
	        _this2.removeOutOfBoundObject(zone, powerUp);_this2.powerUpsMissed++;
	      }, null, this);
	    }
	  }, {
	    key: "createAutoCollectZone",
	    value: function createAutoCollectZone() {
	      this.autoCollectZone = this.add.zone(this.rabbit.sprite.x - this.rabbit.sprite.width / 2, 0, this.rabbit.sprite.width * 2, this.sys.game.config.height);
	      this.physics.world.enable(this.autoCollectZone);
	      this.autoCollectZone.body.allowGravity = false;
	      this.autoCollectZone.body.setImmovable(true);
	      this.physics.add.overlap(this.autoCollectZone, this.carrots, this.magnetCollectCarrot, null, this);
	    }
	  }, {
	    key: "startObjectSpawning",
	    value: function startObjectSpawning() {
	      // Carrots spawn on fixed time
	      this.carrotSpawnTimer = this.time.addEvent({ delay: this.carrotSpawnRate, callback: this.spawnCarrot, callbackScope: this, loop: true });
	      // Obstacles randomly spawn
	      this.spawnObstacle();
	      // Power-ups randomly spawn
	      this.queuePowerUp(Phaser.Math.Between(this.powerUpSpawnRate.min, this.powerUpSpawnRate.max));
	    }
	  }, {
	    key: "update",
	    value: function update(time, delta) {
	      if (this.rabbit.alive && !this.paused) {
	        this.updateCarrotsPosition(time, delta);
	        this.updateObstaclesPosition(time, delta);
	        this.updatePowerUpsPosition(time, delta);
	
	        this.updateTweens();
	      }
	    }
	  }, {
	    key: "updateInput",
	    value: function updateInput(_ref) {
	      var cursors = _ref.cursors,
	          spaceKey = _ref.spaceKey,
	          pointerDown = _ref.pointerDown;
	      var upKey = cursors.upKey;
	
	
	      if (this.rabbit.isTouchingGround()) {
	        this.rabbit.startRunning();
	      } else if (this.rabbit.isFalling()) {
	        this.rabbit.fall();
	      }
	
	      if (this.rabbit.jumping) {
	        this.rabbit.updateShadow();
	      }
	
	      var jumpKeyDown = Phaser.Input.Keyboard.JustDown(upKey) || Phaser.Input.Keyboard.JustDown(spaceKey) || pointerDown;
	
	      if (jumpKeyDown && this.rabbit.isTouchingGround()) {
	        this.rabbit.jump(pointerDown);
	      }
	    }
	  }, {
	    key: "removeOutOfBoundObject",
	    value: function removeOutOfBoundObject(despawnZone, object) {
	      object.destroy();
	    }
	  }, {
	    key: "spawnObstacle",
	    value: function spawnObstacle() {
	      if (this.spawnAllowed) {
	        this.obstacleSpawnTimer = null;
	        var lastObstacle = this.obstacles.getLast(true);
	
	        if (lastObstacle === null || lastObstacle.x + lastObstacle.width + this.minObstacleSpacing <= this.spawnLocation.x) {
	          var newObstacle = this.addRandomObstacle(this.spawnLocation.x, this.spawnLocation.y);
	          var lastCarrot = this.carrots.getLast(true);
	
	          if (newObstacle !== null && lastCarrot !== null) {
	            this.physics.world.overlap(lastCarrot, newObstacle, this.onCarrotObstacleOverlap, null, this);
	          }
	
	          this.queueObstacle(Phaser.Math.Between(this.obstacleSpawnRate.min, this.obstacleSpawnRate.max));
	        }
	      }
	    }
	  }, {
	    key: "queueObstacle",
	    value: function queueObstacle(time) {
	      if (this.obstacleSpawnTimer === null) {
	        this.obstacleSpawnTimer = this.time.addEvent({ delay: time, callback: this.spawnObstacle, callbackScope: this, loop: false });
	      }
	    }
	  }, {
	    key: "spawnCarrot",
	    value: function spawnCarrot() {
	      if (this.spawnAllowed) {
	        var lastCarrot = this.carrots.getLast(true);
	
	        if (lastCarrot === null || lastCarrot.x + lastCarrot.width + this.minCarrotSpacing <= this.spawnLocation.x) {
	          var newCarrot = this.addCarrot(this.spawnLocation.x, null, this.rabbit.hasRocketCake());
	          var lastObstacle = this.obstacles.getLast(true);
	          var lastPowerUp = this.powerUps.getLast(true);
	
	          if (newCarrot !== null) {
	            if (lastObstacle !== null) {
	              this.physics.world.overlap(newCarrot, lastObstacle, this.onCarrotObstacleOverlap, null, this);
	            }
	
	            if (lastPowerUp !== null) {
	              this.physics.world.overlap(newCarrot, lastPowerUp, this.onCarrotPowerUpOverlap, null, this);
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: "onCarrotObstacleOverlap",
	    value: function onCarrotObstacleOverlap(carrot, obstacle) {
	      this.addCarrot(carrot.x, Phaser.Math.Between(1, 2), carrot.doubleValue);
	      carrot.destroy();
	    }
	  }, {
	    key: "onCarrotPowerUpOverlap",
	    value: function onCarrotPowerUpOverlap(carrot, powerUp) {
	      powerUp.x += carrot.width * 3;
	      powerUp.body.x += carrot.width * 3;
	
	      var lastCarrot = this.obstacles.getLast(true);
	      if (lastCarrot !== null) {
	        this.physics.world.overlap(carrot, powerUp, this.onCarrotPowerUpOverlap, null, this);
	      }
	    }
	  }, {
	    key: "spawnPowerUp",
	    value: function spawnPowerUp() {
	      this.powerUpSpawnTimer = null;
	
	      if (this.spawnAllowed) {
	        var lastPowerUp = this.powerUps.getLast(true);
	
	        // Don't spawn powerUps when there is still a powerUp active
	        if (this.rabbit.powerUp === null && lastPowerUp === null) {
	          var newPowerUp = this.addRandomPowerUp(this.spawnLocation.x, Phaser.Math.Between(this.sys.game.config.height - 500, this.sys.game.config.height - 330));
	          var lastCarrot = this.obstacles.getLast(true);
	
	          if (newPowerUp !== null && lastCarrot !== null) {
	            this.physics.world.overlap(lastCarrot, newPowerUp, this.onCarrotPowerUpOverlap, null, this);
	          }
	        }
	      }
	
	      this.queuePowerUp(Phaser.Math.Between(this.powerUpSpawnRate.min, this.powerUpSpawnRate.max));
	    }
	  }, {
	    key: "queuePowerUp",
	    value: function queuePowerUp(time) {
	      if (this.powerUpSpawnTimer === null) {
	        this.powerUpSpawnTimer = this.time.addEvent({ delay: time, callback: this.spawnPowerUp, callbackScope: this, loop: false });
	      }
	    }
	  }, {
	    key: "updateCarrotsPosition",
	    value: function updateCarrotsPosition(time, delta) {
	      this.updateGroupPosition(time, delta, this.carrots);
	    }
	  }, {
	    key: "updateObstaclesPosition",
	    value: function updateObstaclesPosition(time, delta) {
	      this.updateGroupPosition(time, delta, this.obstacles);
	    }
	  }, {
	    key: "updatePowerUpsPosition",
	    value: function updatePowerUpsPosition(time, delta) {
	      this.updateGroupPosition(time, delta, this.powerUps);
	    }
	  }, {
	    key: "updateGroupPosition",
	    value: function updateGroupPosition(time, delta, group) {
	      var that = this;
	      if (group !== null) {
	        group.children.iterate(function (child) {
	          if (!child.attracted) {
	            // child.body.x -= that.trackSpeed;
	            child.body.x -= that.trackSpeed * delta;
	          }
	        });
	      }
	    }
	  }, {
	    key: "updateTweens",
	    value: function updateTweens() {
	      this.carrots.children.iterate(function (child) {
	        if (child.attracted && child.attractTween !== null) {
	          child.attractTween.updateTo("y", this.rabbit.sprite.y);
	        }
	      }, this);
	    }
	  }, {
	    key: "createRabbit",
	    value: function createRabbit() {
	      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
	
	      if (this.rabbit !== null) {
	        this.rabbit.destroy();
	      }
	
	      this.rabbit = new _rabbit2.default(this, x, y);
	
	      // http://labs.phaser.io/index.html?dir=depth%20sorting/&q=
	      // this.children.bringToTop(this.rabbit.sprite);
	      this.rabbit.sprite.setDepth(79);
	
	      return this.rabbit;
	    }
	  }, {
	    key: "addCarrot",
	    value: function addCarrot(x, position, doubleValue) {
	      var y = this.sys.game.config.height;
	
	      if (typeof position === "undefined" || position === null) {
	        position = Phaser.Math.Between(0, 2);
	      }
	
	      switch (position) {
	        case 2:
	          y -= 500;
	          break;
	        case 1:
	          y -= 330;
	          break;
	        case 0:
	        default:
	          y -= 160;
	          break;
	      }
	
	      var _carrot = new _carrot3.default(this, x, y, position, doubleValue);
	
	      // If carrot is not yet in the scene you can use this instead (true means it will also add the carrot to the scene instead of just the group)
	      // No need to worry about this atm since adding to the scene is done automatically in the 'consumable' parent class
	      // this.carrots.add(carrot, true);
	      this.carrots.add(_carrot);
	
	      _carrot.body.allowGravity = false;
	      _carrot.setDepth(49);
	      // Using update function to manually move carrots instead. Not really sure about the the velocity since it relies
	      // on the fps (atm hardcoded 60) which means that if the fps changes the carrots would start moving faster than the track
	      // _carrot.body.velocity.x = -this.trackSpeed * 60;
	
	      return _carrot;
	    }
	  }, {
	    key: "addRandomObstacle",
	    value: function addRandomObstacle() {
	      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
	
	      var index = Phaser.Math.Between(0, _constants2.default.OBSTACLES.length - 1);
	      var obstacleFrame = _constants2.default.OBSTACLES[index];
	
	      var _obstacle = new _obstacle3.default(this, x, y, _constants2.default.ATLAS_KEY, obstacleFrame);
	
	      this.obstacles.add(_obstacle);
	
	      _obstacle.body.allowGravity = false;
	      _obstacle.setDepth(39);
	      // Immovable is needed here even because the rabbit can still move it by jumping on top of the obstacle
	      _obstacle.body.setImmovable(true);
	      _obstacle.body.setSize(_obstacle.width * 0.9, _obstacle.height * 0.9, true);
	      // Not used atm (see `addCarrot` for reason)
	      // _obstacle.body.velocity.x = -this.trackSpeed * 60;
	
	      return _obstacle;
	    }
	  }, {
	    key: "addRandomPowerUp",
	    value: function addRandomPowerUp() {
	      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
	
	      var index = Phaser.Math.Between(0, _constants2.default.POWER_UPS.length - 1);
	
	      var _powerUp = new _powerup2.default(this, x, y, _constants2.default.POWER_UPS[index]);
	
	      this.powerUps.add(_powerUp);
	
	      _powerUp.body.allowGravity = false;
	      _powerUp.body.setImmovable(true);
	      _powerUp.setDepth(50);
	      // Not used atm (see `addCarrot` for reason)
	      // _powerUp.body.velocity.x = -this.trackSpeed * 60;
	
	      return _powerUp;
	    }
	  }, {
	    key: "collectCarrot",
	    value: function collectCarrot(rabbit, carrot) {
	      carrot.destroy();
	      this.events.emit("carrot-taken", carrot);
	    }
	  }, {
	    key: "magnetCollectCarrot",
	    value: function magnetCollectCarrot(zone, carrot) {
	      if (this.rabbit.powerUp !== null && this.rabbit.powerUp.type === "magnet" && !carrot.attracted) {
	        carrot.attracted = true;
	        carrot.attractTween = this.tweens.add({
	          targets: carrot,
	          x: this.rabbit.sprite.x,
	          y: this.rabbit.sprite.y,
	          ease: "Sine.easeIn",
	          duration: 250
	        });
	      }
	    }
	  }, {
	    key: "obstacleHit",
	    value: function obstacleHit(rabbit, obstacle) {
	      if (this.rabbit.powerUp && this.rabbit.powerUp.type === "shield") {
	        return;
	      }
	
	      this.rabbit.alive = false;
	      this.rabbit.flash();
	      this.events.emit("rabbit-collided");
	    }
	  }, {
	    key: "collectPowerUp",
	    value: function collectPowerUp(rabbit, powerUp) {
	      // this.rabbit != rabbit (rabbit is sprite from this.rabbit)
	      this.rabbit.givePowerUp(powerUp);
	
	      this.powerUpTimer = this.time.addEvent({ delay: powerUp.duration, callback: function callback() {
	          this.rabbit.removePowerUp();
	          powerUp.destroy();
	          this.powerUpTimer = null;
	        }, callbackScope: this, loop: false });
	
	      powerUp.disableBody(true, true);
	    }
	  }, {
	    key: "pauseTimers",
	    value: function pauseTimers(flag) {
	      this.pauseTimer(this.obstacleSpawnTimer, flag);
	      this.pauseTimer(this.carrotSpawnTimer, flag);
	      this.pauseTimer(this.powerUpSpawnTimer, flag);
	      this.pauseTimer(this.powerUpTimer, flag);
	    }
	  }, {
	    key: "pauseTimer",
	    value: function pauseTimer(timer, flag) {
	      if (timer) {
	        timer.paused = flag;
	      }
	    }
	  }, {
	    key: "clearTrack",
	    value: function clearTrack() {
	      this.rabbit.destroy();
	
	      this.autoCollectZone.destroy();
	      // Params: removeFromScene, destroyChild
	      this.carrots.clear(true, true);
	      this.obstacles.clear(true, true);
	      this.powerUps.clear(true, true);
	    }
	  }, {
	    key: "paused",
	    get: function get() {
	      return this._paused;
	    },
	    set: function set(paused) {
	      this._paused = paused;
	
	      this.pauseTimers(this.paused);
	      this.spawnAllowed = !this.paused;
	
	      if (this.paused) {
	        this.physics.pause();
	
	        if (this.rabbit !== null) {
	          this.rabbit.sprite.anims.stop();
	        }
	      } else {
	        this.physics.resume();
	
	        if (this.rabbit !== null) {
	          this.rabbit.sprite.anims.play();
	        }
	      }
	    }
	  }]);
	
	  return Track;
	}(Phaser.Scene);
	
	exports.default = Track;

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scenes = __webpack_require__(693);
	
	var scenes = _interopRequireWildcard(_scenes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var config = {
	  title: "chicken-game",
	  version: "0.0.1",
	  url: null,
	
	  /*
	    - `WEBGL`: Use WebGL rendering;
	    - `CANVAS`: Use 'context2D API rendering method;
	    - `AUTO`: Phaser will choose, based on device capabilities, the best rendering method to be used.
	   */
	  type: Phaser.AUTO,
	  width: 960,
	  height: 540,
	  zoom: 1,
	  resolution: 1,
	
	  // Whether to disable antialiasing or not. Great for pixel art.
	  pixelArt: false,
	  // Whether to enable canvas transparency or not.
	  transparent: false,
	
	  canvasStyle: "display: block; margin: 0 auto;",
	  backgroundColor: "#ffffff",
	
	  //physics: {
	  /*
	    - `arcade`: Phaser Arcade Physics 2;
	    - `matter`: Liam Brummitt's (@liabru) Matter.js;
	    - `impact`: ImpactJS Physics Engine.
	   */
	  /*  default: false
	  },*/
	
	  // loader: {
	  // path: "assets/games/carrot-game/"
	  // },
	
	  // scene: Object.values(scenes)
	  scene: Object.keys(scenes).map(function (key) {
	    return scenes[key];
	  })
	}; /**
	    * Created by jv on 15/05/2018.
	    */
	
	//  Import created game scenes.
	exports.default = config;

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 30/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Chick = function (_Phaser$Physics$Arcad) {
	  _inherits(Chick, _Phaser$Physics$Arcad);
	
	  function Chick(scene, options) {
	    var _this;
	
	    _classCallCheck(this, Chick);
	
	    if (!options.hatchPosition || !_constants2.default.CHICK_HATCH_POSITIONS.includes(options.hatchPosition)) {
	      var index = Phaser.Math.Between(0, _constants2.default.CHICK_HATCH_POSITIONS.length - 1);
	      options.hatchPosition = _constants2.default.CHICK_HATCH_POSITIONS[index];
	    }
	
	    (_this = _possibleConstructorReturn(this, (Chick.__proto__ || Object.getPrototypeOf(Chick)).call(this, scene, options.x, options.y, _constants2.default.ATLAS_KEY, "animations/chicks/plop/" + options.hatchPosition + "/0001.png")), _this).setOrigin(0.5);
	
	    _this.spawnPosition = {
	      x: options.x,
	      y: options.y
	    };
	    _this.hatchPosition = options.hatchPosition;
	    _this.draggable = false;
	    _this.onHatch = options.onHatch;
	
	    _this.hatching = false;
	
	    _this.escaped = false;
	    _this.runningOutside = false;
	
	    _this.runTween = null;
	    _this.runningTo = null;
	
	    _this.flashTween = null;
	
	    _this.on("animationcomplete", function () {
	      if (_this.hatching) {
	        _this.hatching = false;
	        if (typeof _this.onHatch === "function") _this.onHatch.call(null, _this);
	      }
	    }, _this);
	    return _this;
	  }
	
	  _createClass(Chick, [{
	    key: "hatch",
	    value: function hatch() {
	      this.hatching = true;
	      this.anims.play("chick-plop-" + this.hatchPosition, true);
	    }
	  }, {
	    key: "runTo",
	    value: function runTo(x, y, duration, callback) {
	      var _this2 = this;
	
	      if (this.runTween !== null) {
	        // Still running
	        return;
	      }
	
	      this.runningTo = { x: x, y: y };
	
	      var v = new Phaser.Math.Vector2(x - this.x, y - this.y).normalize();
	      var cutoff = 0.35;
	
	      this.startRunAnimation(this.getDirectionForVector(v, cutoff));
	
	      duration = duration ? duration : 6000;
	
	      this.runTween = this.scene.tweens.add({
	        targets: this,
	        props: {
	          x: { value: x, duration: duration },
	          y: { value: y, duration: duration }
	        },
	        onComplete: function onComplete() {
	          _this2.runTween = null;
	          _this2.runningTo = null;
	          _this2.anims.stop();
	          if (typeof callback === "function") {
	            callback.call(null, _this2);
	          }
	        }
	      });
	    }
	  }, {
	    key: "pauseRunning",
	    value: function pauseRunning() {
	      if (this.runTween !== null) {
	        this.runTween.pause();
	      }
	    }
	  }, {
	    key: "resumeRunning",
	    value: function resumeRunning() {
	      if (this.runTween !== null) {
	        this.runTween.resume();
	      }
	    }
	  }, {
	    key: "stopRunning",
	    value: function stopRunning() {
	      if (this.runTween !== null) {
	        this.runTween.stop();
	        this.runningTo = null;
	        this.runTween = null;
	      }
	    }
	  }, {
	    key: "startRunAnimation",
	    value: function startRunAnimation(direction) {
	      this.anims.play("chick-run-" + direction, true);
	    }
	  }, {
	    key: "flash",
	    value: function flash() {
	      var startColor = Phaser.Display.Color.HexStringToColor("#ff0000"),
	          endColor = Phaser.Display.Color.HexStringToColor("#ffffff");
	
	      if (this.flashTween !== null && this.flashTween.isPlaying()) {
	        // this.flashTween.stop();
	        return;
	      }
	
	      var that = this;
	
	      this.flashTween = this.scene.tweens.addCounter({
	        from: 0,
	        to: 100,
	        loop: 1,
	        duration: 1000,
	        onUpdate: function onUpdate() {
	          that.tint = Phaser.Display.Color.ObjectToColor(Phaser.Display.Color.Interpolate.ColorWithColor(startColor, endColor, 100, that.flashTween.getValue())).color;
	        },
	        onComplete: function onComplete() {}
	      });
	    }
	  }, {
	    key: "getDirectionForVector",
	    value: function getDirectionForVector(v, cutoff) {
	      if (Math.abs(v.x) > 1 - cutoff && Math.abs(v.y) < 0 + cutoff || Math.abs(v.y) > 1 - cutoff && Math.abs(v.x) < 0 + cutoff) {
	        var vAbs = { x: Math.abs(v.x), y: Math.abs(v.y) };
	
	        if (v.x >= 0 && vAbs.x > vAbs.y) {
	          return "e";
	        } else if (v.x <= 0 && vAbs.x > vAbs.y) {
	          return "w";
	        } else if (v.y >= 0 && vAbs.y > vAbs.x) {
	          return "s";
	        } else if (v.y <= 0 && vAbs.y > vAbs.x) {
	          return "n";
	        }
	      } else {
	        if (v.x > 0 && v.y < 0) {
	          return "ne";
	        } else if (v.x > 0 && v.y > 0) {
	          return "se";
	        } else if (v.x < 0 && v.y < 0) {
	          return "nw";
	        } else if (v.x < 0 && v.y > 0) {
	          return "sw";
	        }
	      }
	    }
	  }]);
	
	  return Chick;
	}(Phaser.Physics.Arcade.Sprite);
	
	exports.default = Chick;

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 30/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Corinne = function () {
	  function Corinne(scene, x, y) {
	    _classCallCheck(this, Corinne);
	
	    this.scene = scene;
	
	    this.sprite = this.scene.add.sprite(x, y, _constants2.default.ATLAS_KEY, "animations/corinne/0000.png").setOrigin(0.5);
	
	    if (_constants2.default.DEBUG) {
	      var graphics = this.scene.add.graphics();
	      graphics.lineStyle(1, 0xff0000, 1);
	
	      graphics.strokeRectShape(this.sprite.getBounds());
	    }
	  }
	
	  _createClass(Corinne, [{
	    key: "destroy",
	    value: function destroy() {
	      this.sprite.destroy();
	    }
	  }, {
	    key: "startIdleAnimation",
	    value: function startIdleAnimation() {
	      this.sprite.anims.play("corinne-idle", true);
	    }
	  }]);
	
	  return Corinne;
	}();
	
	exports.default = Corinne;

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _corinne = __webpack_require__(689);
	
	var _corinne2 = _interopRequireDefault(_corinne);
	
	var _chick2 = __webpack_require__(688);
	
	var _chick3 = _interopRequireDefault(_chick2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 30/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Coop = function (_Phaser$Scene) {
	  _inherits(Coop, _Phaser$Scene);
	
	  function Coop() {
	    _classCallCheck(this, Coop);
	
	    var _this = _possibleConstructorReturn(this, (Coop.__proto__ || Object.getPrototypeOf(Coop)).call(this, {
	      key: "Coop",
	      physics: {
	        default: "arcade",
	        arcade: {
	          gravity: { y: 0 },
	          debug: _constants2.default.DEBUG
	        }
	      }
	    }));
	
	    _this.corinne = null;
	    _this.chicks = null;
	
	    // zone-only means you can only drop the chicks on the nest, dropping it anywhere else will put them back in their
	    // previous position
	    _this.dropMode = _constants2.default.DROP_MODE;
	
	    // Calculated from center
	    _this.nestPosition = {
	      x: 0,
	      y: 55
	    };
	
	    // Calculated from center of nest
	    _this.corinnePosition = {
	      x: 5,
	      y: -70
	    };
	
	    _this.chickSpawnRate = { min: 5 * 1000, max: 15 * 1000 };
	    _this.maxChickCount = 25;
	
	    _this.fenceBoundaries = null;
	    _this.fenceGaps = null;
	
	    _this.spawnPositions = null;
	    return _this;
	  }
	
	  _createClass(Coop, [{
	    key: "init",
	    value: function init() {
	      this.paused = false;
	
	      var gameWidth = this.sys.game.config.width,
	          gameHeight = this.sys.game.config.height;
	
	      this.spawnAllowed = true;
	      this.chickSpawnTimer = null;
	      this.chicksOutside = 0;
	
	      this.physics.world.setBounds(-100, -100, gameWidth + 200, gameHeight + 200);
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      var gameWidth = this.sys.game.config.width,
	          gameHeight = this.sys.game.config.height;
	
	      // Fence
	      this.fence = this.add.image(0, 0, _constants2.default.ATLAS_KEY, "scene/fence.png").setOrigin(0).setDisplaySize(gameWidth, gameHeight).setDepth(99);
	      // Create Zone
	      this.createFenceZone();
	      this.calculateRunToPositions();
	
	      // Create nest
	      this.nest = this.add.sprite(gameWidth / 2 + this.nestPosition.x, gameHeight / 2 + this.nestPosition.y, _constants2.default.ATLAS_KEY, "scene/nest.png").setOrigin(0.5);
	      this.calculateSpawnPositions();
	      //  Drop zone for chicks
	      this.chickDropZone = this.add.zone(this.nest.x, this.nest.y, this.nest.width - 10, this.nest.height - 10).setName("chick-drop-zone").setDropZone();
	
	      // Create corinne
	      this.spawnCorinne(this.nest.x + this.corinnePosition.x, this.nest.y + this.corinnePosition.y);
	      this.corinne.startIdleAnimation();
	
	      // Create chicks group
	      this.chicks = this.physics.add.group({
	        maxSize: this.maxChickCount,
	        createCallback: function createCallback(chick) {
	          console.log("created chick");
	        },
	        removeCallback: function removeCallback(chick) {
	          console.log("removed chick");
	        }
	      });
	
	      // Add colliders
	      // let chicks collide with each other
	      this.physics.add.collider(this.chicks, this.chicks, null, null, this);
	      this.physics.add.overlap(this.chicks, this.fenceZone, this.onChickFenceCollide, null, this);
	      this.physics.add.overlap(this.chicks, this.coopZone, this.onChickGrassCollide, null, this);
	
	      // Add drag event listener
	      this.setUpDragListener();
	
	      // Start chick spawning
	      this.spawnChick();
	
	      if (_constants2.default.DEBUG) {
	        this.debugGraphics = this.add.graphics();
	        this.debugGraphics.lineStyle(1, 0xff0000, 1);
	
	        this.debugGraphics.strokeRectShape(this.nest.getBounds());
	
	        this.debugGraphics.lineStyle(2, 0xffff00);
	        this.debugGraphics.strokeRect(this.chickDropZone.x + this.chickDropZone.input.hitArea.x, this.chickDropZone.y + this.chickDropZone.input.hitArea.y, this.chickDropZone.input.hitArea.width, this.chickDropZone.input.hitArea.height);
	      }
	    }
	  }, {
	    key: "createFenceZone",
	    value: function createFenceZone() {
	      this.fenceZone = this.physics.add.group({ immovable: true });
	      this.coopZone = this.physics.add.group({ immovable: true });
	
	      this.fenceBoundaries = {
	        x: this.fence.frame.x + 20,
	        y: this.fence.frame.y + 40,
	        width: this.fence.frame.width - 45,
	        height: this.fence.frame.height - 50
	      };
	
	      var chickFrame = this.scene.systems.game.textures.getFrame(_constants2.default.ATLAS_KEY, "animations/chicks/run/n/0001.png");
	
	      this.grassBoundaries = {
	        x: this.fence.frame.x + 50 - chickFrame.width / 2,
	        y: this.fence.frame.y + 70 - chickFrame.height / 2,
	        width: this.fence.frame.width - 100 + chickFrame.width,
	        height: this.fence.frame.height - 80 + chickFrame.width
	      };
	
	      // TOP
	      this.createFenceBoundary(this.fenceZone, "fence-top", this.fenceBoundaries.x, this.fenceBoundaries.y, this.fenceBoundaries.width, 1);
	      // LEFT
	      this.createFenceBoundary(this.fenceZone, "fence-left", this.fenceBoundaries.x, this.fenceBoundaries.y, 1, this.fenceBoundaries.height);
	      // BOTTOM
	      this.createFenceBoundary(this.fenceZone, "fence-bottom", this.fenceBoundaries.x, this.fenceBoundaries.y + this.fenceBoundaries.height, this.fenceBoundaries.width, 1);
	      // RIGHT
	      this.createFenceBoundary(this.fenceZone, "fence-right", this.fenceBoundaries.x + this.fenceBoundaries.width, this.fenceBoundaries.y, 1, this.fenceBoundaries.height);
	
	      // TOP
	      this.createFenceBoundary(this.coopZone, "coop-boundary-top", this.grassBoundaries.x, this.grassBoundaries.y, this.grassBoundaries.width, 1);
	      // LEFT
	      this.createFenceBoundary(this.coopZone, "coop-boundary-left", this.grassBoundaries.x, this.grassBoundaries.y, 1, this.grassBoundaries.height);
	      // BOTTOM
	      this.createFenceBoundary(this.coopZone, "coop-boundary-bottom", this.grassBoundaries.x, this.grassBoundaries.y + this.grassBoundaries.height, this.grassBoundaries.width, 1);
	      // RIGHT
	      this.createFenceBoundary(this.coopZone, "coop-boundary-right", this.grassBoundaries.x + this.grassBoundaries.width, this.grassBoundaries.y, 1, this.grassBoundaries.height);
	    }
	  }, {
	    key: "createFenceBoundary",
	    value: function createFenceBoundary(group, name, x, y, width, height) {
	      var fenceBoundary = this.add.zone(x, y, width, height);
	      fenceBoundary.setName(name);
	      group.add(fenceBoundary);
	    }
	  }, {
	    key: "setUpDragListener",
	    value: function setUpDragListener() {
	      var _this2 = this;
	
	      this.input.off("drag").on("drag", function (pointer, chick, dragX, dragY) {
	        if (chick instanceof _chick3.default && _this2.chicksOutside === 0) {
	          chick.x = dragX;
	          chick.y = dragY;
	        }
	      });
	
	      this.input.off("dragstart").on("dragstart", function (pointer, chick) {
	        if (chick instanceof _chick3.default && _this2.chicksOutside === 0) {
	          if (_this2.dropMode === _constants2.default.DROP_MODES.ZONE_ONLY) {
	            chick.pauseRunning();
	          } else {
	            chick.stopRunning();
	          }
	        }
	      });
	
	      this.input.off("dragend").on("dragend", function (pointer, chick) {
	        if (chick instanceof _chick3.default && _this2.chicksOutside === 0) {
	          if (_this2.dropMode === _constants2.default.DROP_MODES.ZONE_ONLY) {
	            chick.resumeRunning();
	          } else {
	            chick.stopRunning();
	
	            var runToPos = _this2.getRandomRunToPosition(chick.x, chick.y);
	            chick.runTo(runToPos.x, runToPos.y);
	          }
	        }
	      });
	
	      this.input.off("drop").on("drop", function (pointer, chick, dropZone) {
	        if (chick instanceof _chick3.default && dropZone.name === "chick-drop-zone" && _this2.chicksOutside === 0) {
	          chick.stopRunning();
	
	          var spawnPosition = _this2.getRandomSpawnPosition(chick.hatchPosition);
	
	          chick.x = spawnPosition.x;
	          chick.y = spawnPosition.y;
	
	          var runToPos = _this2.getRandomRunToPosition(chick.x, chick.y);
	          chick.runTo(runToPos.x, runToPos.y);
	        }
	      });
	    }
	  }, {
	    key: "update",
	    value: function update(time) {
	      if (!this.paused) {}
	    }
	  }, {
	    key: "pauseAnimations",
	    value: function pauseAnimations(flag) {
	      if (this.corinne !== null) {
	        this.pauseAnimation(this.corinne.sprite, flag);
	      }
	    }
	  }, {
	    key: "pauseAnimation",
	    value: function pauseAnimation(sprite, flag) {
	      if (sprite !== null) {
	        if (flag) {
	          sprite.anims.stop();
	        } else {
	          sprite.anims.play();
	        }
	      }
	    }
	  }, {
	    key: "pauseChicks",
	    value: function pauseChicks(flag) {
	      var _this3 = this;
	
	      if (this.chicks !== null) {
	        this.chicks.children.iterate(function (chick) {
	          // Let escaped chicks keep running
	          if (!chick.escaped) {
	            _this3.pauseAnimation(chick, flag);
	
	            if (flag) {
	              chick.pauseRunning();
	            } else {
	              chick.resumeRunning();
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "pauseTimers",
	    value: function pauseTimers(flag) {
	      this.pauseTimer(this.chickSpawnTimer, flag);
	    }
	  }, {
	    key: "pauseTimer",
	    value: function pauseTimer(timer, flag) {
	      if (timer) {
	        timer.paused = flag;
	      }
	    }
	  }, {
	    key: "clearCoop",
	    value: function clearCoop() {
	      this.corinne.destroy();
	      this.chicks.clear(true, true);
	    }
	  }, {
	    key: "calculateRunToPositions",
	    value: function calculateRunToPositions() {
	      var fenceWidth = this.fenceBoundaries.width,
	          fenceHeight = this.fenceBoundaries.height;
	      var fenceSides = ["top", "right", "bottom", "left"];
	
	      this.fenceGaps = {};
	
	      var lengthGaps = 4;
	      var lengthSpacing = fenceWidth / (lengthGaps + 1);
	      var heightGaps = 3;
	      var heightSpacing = fenceHeight / (heightGaps + 1);
	
	      // Corners are only added on 1 side (top and bottom)
	      // Sides currently don't really matter but adding corners to left and right as well means they'll have a higher
	      // chance to be picked over the other positions.
	
	      for (var i = 0; i < fenceSides.length; i++) {
	        var x = this.fenceBoundaries.x;
	        // var x = this.fenceBoundaries.x + lengthSpacing;
	        var top = this.fenceBoundaries.y;
	        var bottom = this.fenceBoundaries.y + this.fenceBoundaries.height;
	
	        // var y = this.fenceBoundaries.y;
	        var y = this.fenceBoundaries.y + heightSpacing;
	        var left = this.fenceBoundaries.x;
	        var right = this.fenceBoundaries.x + this.fenceBoundaries.width;
	
	        // +2 for the corners
	        var gaps = fenceSides[i] === "top" || fenceSides[i] === "bottom" ? lengthGaps + 2 : heightGaps;
	
	        var fenceGapsForSide = [];
	
	        for (var j = 0; j < gaps; j++) {
	          if (fenceSides[i] === "top") {
	            fenceGapsForSide.push({ x: x, y: top });
	          } else if (fenceSides[i] === "bottom") {
	            fenceGapsForSide.push({ x: x, y: bottom });
	          } else if (fenceSides[i] === "left") {
	            fenceGapsForSide.push({ x: left, y: y });
	          } else if (fenceSides[i] === "right") {
	            fenceGapsForSide.push({ x: right, y: y });
	          }
	
	          x += lengthSpacing;
	          y += heightSpacing;
	        }
	
	        this.fenceGaps[fenceSides[i]] = fenceGapsForSide;
	      }
	
	      if (_constants2.default.DEBUG) {
	        var graphics = this.add.graphics();
	        graphics.setDepth(999);
	        graphics.lineStyle(2, 0x00ffff, 1);
	
	        graphics.beginPath();
	
	        for (var side in this.fenceGaps) {
	          if (this.fenceGaps.hasOwnProperty(side)) {
	            for (var i = 0; i < this.fenceGaps[side].length; i++) {
	              graphics.strokeCircle(this.fenceGaps[side][i].x, this.fenceGaps[side][i].y, 10);
	            }
	          }
	        }
	
	        // graphics.moveTo(this.fenceGaps.top[i].x, this.fenceGaps.top[i].y);
	        // graphics.lineTo(this.fenceGaps.bottom[i].x, this.fenceGaps.bottom[i].y);
	        // graphics.strokePath();
	
	        graphics.closePath();
	      }
	    }
	  }, {
	    key: "calculateSpawnPositions",
	    value: function calculateSpawnPositions() {
	      this.spawnPositions = {
	        top: [{ x: this.nest.x, y: this.nest.y - 40 }],
	        left: [{ x: this.nest.x - 40, y: this.nest.y - 30 }, { x: this.nest.x - 50, y: this.nest.y }, { x: this.nest.x - 40, y: this.nest.y + 30 }],
	        bottom: [{ x: this.nest.x, y: this.nest.y + 40 }],
	        right: [{ x: this.nest.x + 40, y: this.nest.y - 30 }, { x: this.nest.x + 50, y: this.nest.y }, { x: this.nest.x + 40, y: this.nest.y + 30 }]
	      };
	
	      if (_constants2.default.DEBUG) {
	        var graphics = this.add.graphics();
	        graphics.setDepth(999);
	        graphics.lineStyle(2, 0x00ffff, 1);
	
	        graphics.beginPath();
	
	        for (var side in this.spawnPositions) {
	          if (this.spawnPositions.hasOwnProperty(side)) {
	            for (var i = 0; i < this.spawnPositions[side].length; i++) {
	              graphics.strokeCircle(this.spawnPositions[side][i].x, this.spawnPositions[side][i].y, 5);
	            }
	          }
	        }
	
	        graphics.closePath();
	      }
	    }
	  }, {
	    key: "getRandomRunToPosition",
	    value: function getRandomRunToPosition(x, y) {
	      var positions = [];
	
	      for (var side in this.fenceGaps) {
	        if (this.fenceGaps.hasOwnProperty(side)) // && sides === null || sides.includes(side))
	          {
	            for (var i = 0; i < this.fenceGaps[side].length; i++) {
	              var pos = this.fenceGaps[side][i];
	
	              if (x >= this.nest.x && pos.x >= this.nest.x || x <= this.nest.x && pos.x <= this.nest.x) {
	                if (y >= this.nest.y && pos.y >= this.nest.y || y <= this.nest.y && pos.y <= this.nest.y) {
	                  positions.push(pos);
	                }
	              }
	            }
	          }
	      }
	
	      var randomIndex = Phaser.Math.Between(0, positions.length - 1);
	      return positions[randomIndex];
	    }
	  }, {
	    key: "spawnCorinne",
	    value: function spawnCorinne() {
	      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
	
	      if (this.corinne !== null) {
	        this.corinne.destroy();
	      }
	
	      this.corinne = new _corinne2.default(this, x, y);
	
	      // http://labs.phaser.io/index.html?dir=depth%20sorting/&q=
	      // this.corinne.sprite.setDepth(79);
	      this.corinne.sprite.setDepth(99);
	
	      return this.corinne;
	    }
	  }, {
	    key: "spawnChick",
	    value: function spawnChick() {
	      if (this.spawnAllowed) {
	        this.chickSpawnTimer = null;
	        var chickCount = this.chicks.children.size;
	
	        if (chickCount < this.maxChickCount) {
	          var _chick = this.createChick();
	          _chick.hatch();
	
	          // Maybe check overlap with other chicks?
	        }
	
	        this.queueChick(Phaser.Math.Between(this.chickSpawnRate.min, this.chickSpawnRate.max));
	      }
	    }
	  }, {
	    key: "queueChick",
	    value: function queueChick(time) {
	      if (this.chickSpawnTimer === null) {
	        this.chickSpawnTimer = this.time.addEvent({ delay: time, callback: this.spawnChick, callbackScope: this, loop: false });
	      }
	    }
	  }, {
	    key: "createChick",
	    value: function createChick() {
	      var _this4 = this;
	
	      var position = _constants2.default.CHICK_HATCH_POSITIONS[Phaser.Math.Between(0, _constants2.default.CHICK_HATCH_POSITIONS.length - 1)];;
	
	      var spawnPosition = this.getRandomSpawnPosition(position);
	
	      var _chick = new _chick3.default(this, {
	        x: spawnPosition.x,
	        y: spawnPosition.y,
	        hatchPosition: position,
	        onHatch: function onHatch(chick) {
	          var runToPos = _this4.getRandomRunToPosition(chick.spawnPosition.x, chick.spawnPosition.y);
	          chick.runTo(runToPos.x, runToPos.y);
	        }
	      });
	
	      this.sys.displayList.add(_chick);
	      this.sys.updateList.add(_chick);
	      this.physics.world.enableBody(_chick);
	
	      this.chicks.add(_chick);
	      _chick.setDepth(89);
	
	      _chick.body.allowGravity = false;
	      _chick.setBounce(0);
	      _chick.setCollideWorldBounds(true);
	      // _chick.body.setImmovable(true);
	
	      _chick.setInteractive();
	      this.input.setDraggable(_chick);
	
	      return _chick;
	    }
	  }, {
	    key: "getRandomSpawnPosition",
	    value: function getRandomSpawnPosition(side) {
	      if (this.spawnPositions.hasOwnProperty(side)) {
	        return this.spawnPositions[side][Phaser.Math.Between(0, this.spawnPositions[side].length - 1)];
	      }
	
	      return null;
	    }
	  }, {
	    key: "onChickGrassCollide",
	    value: function onChickGrassCollide(chick, fence) {
	      if (chick.escaped) {
	        return;
	      }
	
	      this.chicksOutside++;
	      chick.escaped = true;
	      chick.flash();
	
	      this.events.emit("chick-escaped", chick);
	    }
	  }, {
	    key: "onChickFenceCollide",
	    value: function onChickFenceCollide(chick, fence) {
	      if (chick.runningOutside) {
	        return;
	      }
	
	      var gameWidth = this.sys.game.config.width,
	          gameHeight = this.sys.game.config.height;
	      chick.stopRunning();
	
	      chick.runningOutside = true;
	
	      if (fence.name === "fence-top") {
	        chick.runTo(chick.x, -100, 2000);
	      } else if (fence.name === "fence-left") {
	        chick.runTo(-100, chick.y, 3000);
	      } else if (fence.name === "fence-bottom") {
	        chick.runTo(chick.x, gameHeight + 100, 2000);
	      } else if (fence.name === "fence-right") {
	        chick.runTo(gameWidth + 100, chick.y, 3000);
	      }
	    }
	  }, {
	    key: "paused",
	    get: function get() {
	      return this._paused;
	    },
	    set: function set(paused) {
	      this._paused = paused;
	
	      this.pauseTimers(this.paused);
	      this.pauseAnimations(this.paused);
	      this.pauseChicks(this.paused);
	      this.spawnAllowed = !this.paused;
	
	      if (this.paused) {
	        this.physics.pause();
	      } else {
	        this.physics.resume();
	      }
	    }
	  }]);
	
	  return Coop;
	}(Phaser.Scene);
	
	exports.default = Coop;

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(25);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _text = __webpack_require__(371);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 25/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Text = void 0;
	
	var GameOver = function (_Phaser$Scene) {
	  _inherits(GameOver, _Phaser$Scene);
	
	  function GameOver() {
	    _classCallCheck(this, GameOver);
	
	    return _possibleConstructorReturn(this, (GameOver.__proto__ || Object.getPrototypeOf(GameOver)).call(this, {
	      key: "GameOver"
	    }));
	  }
	
	  _createClass(GameOver, [{
	    key: "init",
	    value: function init(_ref) {
	      var gameScene = _ref.gameScene;
	
	      Text = (0, _text2.default)();
	      this.gameScene = gameScene;
	      this.gameScene.events.off("game-end").on("game-end", function () {
	        this.setHighScore();
	        this.setVisible(true);
	      }, this);
	
	      this.scene.setVisible(false);
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      var _this2 = this;
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.backdrop = this.add.image(0, 0, _constants2.default.ATLAS_KEY, "misc/bg_overlay.png").setOrigin(0, 0);
	
	      this.add.text(gameWidth / 2, gameHeight / 4, Text.gameOver.title, { fontFamily: "RabbitOnTheMoon", fontSize: 48, fontWeight: "normal", fill: "#FFFFFF" }).setOrigin(0.5);
	
	      this.highScoreLabel = this.add.text(gameWidth / 2, gameHeight / 2, "", { fontFamily: "RabbitOnTheMoon", fontSize: 36, fontWeight: "normal", fill: "#FFFFFF" }).setOrigin(0.5);
	
	      var buttonImageHeight = this.scene.systems.game.textures.getFrame(_constants2.default.ATLAS_KEY, "misc/button.png").realHeight;
	      var buttonImage = this.add.image(gameWidth / 2, gameHeight - buttonImageHeight * 1.5, _constants2.default.ATLAS_KEY, "misc/button.png").setOrigin(0.5, 1);
	      var restartIconWidth = this.scene.systems.game.textures.getFrame(_constants2.default.ATLAS_KEY, "misc/icon_restart.png").realWidth;
	      var startButtonText = this.add.text(buttonImage.x + restartIconWidth, buttonImage.y - buttonImage.height / 2, Text.gameOver.replayBtn, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 18, fill: "#ffffff" }).setOrigin(0.5).setPadding({ left: 15 });
	      this.add.image(startButtonText.x - startButtonText.width / 2, startButtonText.y, _constants2.default.ATLAS_KEY, "misc/icon_restart.png").setOrigin(1, 0.5);
	
	      this.replayBtnZone = this.add.zone(buttonImage.x - buttonImage.width * buttonImage.originX - 5, buttonImage.y - buttonImage.height * buttonImage.originY - 5, buttonImage.width + 10, buttonImage.height + 10).setName("replay-button").once("pointerup", function () {
	        _this2.input.mouse.target.style.cursor = "";
	        _this2.gameScene.restart();
	      }, this).on("pointerover", function (e) {
	        _this2.input.mouse.target.style.cursor = "pointer";
	      }).on("pointerout", function (e) {
	        _this2.input.mouse.target.style.cursor = "";
	      });
	    }
	  }, {
	    key: "setHighScore",
	    value: function setHighScore() {
	      var highScoreText = Text.gameOver.highScore + _utils2.default.formatTime(this.gameScene.bestTime, "mm:ss");
	      this.highScoreLabel.setText(highScoreText);
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(flag) {
	      if (flag) {
	        this.replayBtnZone.setInteractive();
	      } else {
	        this.replayBtnZone.removeInteractive();
	      }
	
	      this.scene.setVisible(flag);
	    }
	  }]);
	
	  return GameOver;
	}(Phaser.Scene);
	
	exports.default = GameOver;

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Game = function (_Phaser$Scene) {
	  _inherits(Game, _Phaser$Scene);
	
	  function Game() {
	    _classCallCheck(this, Game);
	
	    /**
	     *  Keep the last high score registered.
	     */
	    var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this, { key: "Game" }));
	
	    _this.bestTime = 0;
	    return _this;
	  }
	
	  _createClass(Game, [{
	    key: "init",
	    value: function init() {
	      // https://github.com/photonstorm/phaser/issues/3185
	      this.scene.launch("Coop").launch("Menu", { type: "pause-menu" }).launch("Scoreboard", { gameScene: this }).launch("GameOver", { gameScene: this });
	
	      this.timePlaying = 0;
	
	      this.gameOver = false;
	      this.paused = false;
	      this.debug = _constants2.default.DEBUG;
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.coop = this.scene.get("Coop");
	
	      this.setSceneOrder();
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.sand = this.add.image(0, 0, _constants2.default.ATLAS_KEY, "scene/sand.jpg").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
	      this.grass = this.add.image(0, 0, _constants2.default.ATLAS_KEY, "scene/grass.png").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
	
	      this.coop.events.off("chick-escaped").on("chick-escaped", this.chickEscaped, this);
	
	      this.gameTimer = this.time.addEvent({ delay: 1000, callback: this.increaseGameTime, callbackScope: this, loop: true });
	    }
	  }, {
	    key: "setSceneOrder",
	    value: function setSceneOrder() {
	      this.scene.moveAbove("Game", "Coop");
	      this.scene.moveAbove("Coop", "Scoreboard");
	      this.scene.moveAbove("Scoreboard", "Menu");
	      this.scene.moveAbove("Menu", "GameOver");
	    }
	  }, {
	    key: "update",
	    value: function update(time, delta) {
	      this._updateDebugText();
	
	      if (!this.gameOver && !this.paused) {
	        this.updateLogic(time);
	      }
	    }
	  }, {
	    key: "updateLogic",
	    value: function updateLogic(time) {}
	  }, {
	    key: "endGame",
	    value: function endGame() {
	      var _this2 = this;
	
	      this.gameOver = true;
	
	      //  Update the high score.
	      this.bestTime = Math.max(this.timePlaying, this.bestTime);
	
	      this.scene.get("Scoreboard").setHelpButtonInteractive(false);
	
	      this.pause();
	
	      this.time.delayedCall(1000, function () {
	        _this2.coop.clearCoop();
	        _this2.events.emit("game-end");
	      });
	    }
	  }, {
	    key: "restart",
	    value: function restart() {
	      this.scene.stop("Coop").stop("Scoreboard").stop("Menu").stop("GameOver").start("Game");
	    }
	  }, {
	    key: "resume",
	    value: function resume() {
	      this.paused = false;
	
	      this.gameTimer.paused = false;
	      this.scene.get("Coop").paused = false;
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.paused = true;
	
	      this.gameTimer.paused = true;
	      this.scene.get("Coop").paused = true;
	    }
	  }, {
	    key: "togglePause",
	    value: function togglePause() {
	      if (this.paused) {
	        this.resume();
	      } else {
	        this.pause();
	      }
	    }
	  }, {
	    key: "chickEscaped",
	    value: function chickEscaped(chick) {
	      this.endGame();
	    }
	  }, {
	    key: "increaseGameTime",
	    value: function increaseGameTime() {
	      this.events.emit("game-time-updated", ++this.timePlaying);
	    }
	  }, {
	    key: "_updateDebugText",
	    value: function _updateDebugText() {
	      if (this.debug) {
	        var textContent = [];
	
	        textContent.push("Time: " + this.timePlaying);
	        textContent.push("Best time: " + this.bestTime);
	        textContent.push("Game over: " + this.gameOver);
	        textContent.push("Chicks in coop: " + this.coop.chicks.children.size);
	        var timeTillNextChickSpawn = "/";
	        if (this.coop.chickSpawnTimer !== null) {
	          timeTillNextChickSpawn = Math.round(this.coop.chickSpawnTimer.delay / 1000) - Math.round(this.coop.chickSpawnTimer.getElapsedSeconds());
	        }
	        textContent.push("Time until chick spawn: " + timeTillNextChickSpawn + "s");
	
	        this.scene.get("Scoreboard")._debugText.setText(textContent);
	      }
	    }
	  }]);
	
	  return Game;
	}(Phaser.Scene);
	
	exports.default = Game;

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loader = __webpack_require__(694);
	
	Object.defineProperty(exports, "Loader", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loader).default;
	  }
	});
	
	var _menu = __webpack_require__(695);
	
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_menu).default;
	  }
	});
	
	var _game = __webpack_require__(692);
	
	Object.defineProperty(exports, "Game", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_game).default;
	  }
	});
	
	var _scoreboard = __webpack_require__(696);
	
	Object.defineProperty(exports, "Scoreboard", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scoreboard).default;
	  }
	});
	
	var _gameOver = __webpack_require__(691);
	
	Object.defineProperty(exports, "GameOver", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gameOver).default;
	  }
	});
	
	var _coop = __webpack_require__(690);
	
	Object.defineProperty(exports, "Coop", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_coop).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// const chickenGameAtlas0 = require("Images/games/chicken-game/atlas_chicken-game-0.png");
	// const chickenGameAtlas1 = require("Images/games/chicken-game/atlas_chicken-game-1.png");
	var atlasReq = __webpack_require__(368);
	var chickenGameAtlasJson = __webpack_require__(985);
	
	var Loader = function (_Phaser$Scene) {
	  _inherits(Loader, _Phaser$Scene);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).call(this, {
	      key: "Loader"
	    }));
	  }
	
	  _createClass(Loader, [{
	    key: "init",
	    value: function init() {
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.add.text(gameWidth / 2, gameHeight / 2, "Loading...", { fontFamily: "RabbitOnTheMoon", fontSize: 18, fontWeight: "normal", fill: "#000000" }).setOrigin(0.5);
	    }
	  }, {
	    key: "preload",
	    value: function preload() {
	      // https://labs.phaser.io/index.html?dir=loader/texture%20atlas%20multi/&q=
	      // this.load.atlas(CONSTANTS.ATLAS_KEY, [ chickenGameAtlas0, chickenGameAtlas1 ], chickenGameAtlasJson);
	
	      this.processAtlasJson();
	      // https://photonstorm.github.io/phaser3-docs/Phaser.Loader.LoaderPlugin.html#multiatlas
	      this.load.multiatlas(_constants2.default.ATLAS_KEY, chickenGameAtlasJson);
	      this.loadFonts();
	    }
	  }, {
	    key: "processAtlasJson",
	    value: function processAtlasJson() {
	      // Phaser's multiatlas looks at the images inside the atlas json file. Since we're using webpack we don't know what
	      // the url will be for our atlas .png files ... With this we require them (getting the actual url) and overwrite
	      // them in the json data (not the file itself) before giving it to Phaser
	      for (var i = 0; i < chickenGameAtlasJson.textures.length; i++) {
	        var image = chickenGameAtlasJson.textures[i].image;
	
	        var atlasRequire = "./" + image;
	
	        if (atlasReq.keys().includes(atlasRequire)) {
	          chickenGameAtlasJson.textures[i].image = atlasReq(atlasRequire);
	        } else {
	          console.warning("Atlas '" + image + "' not found");
	        }
	      }
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.createAnimations();
	      this.scene.start("Menu");
	    }
	  }, {
	    key: "loadFonts",
	    value: function loadFonts() {
	      this.preloadFont("RabbitOnTheMoon");
	      this.preloadFont("AbadiMTPro-CondExtraBold");
	    }
	  }, {
	    key: "preloadFont",
	    value: function preloadFont(font) {
	      var text = this.add.text(0, 0, "text", { fontFamily: font, fontSize: 1, fill: "#FFFFFF" });
	      text.visible = false;
	    }
	  }, {
	    key: "createAnimations",
	    value: function createAnimations() {
	      // Chick run animations
	      for (var i = 0; i < _constants2.default.CHICK_RUN_DIRECTIONS.length; i++) {
	        this.createChickRunAnimation(_constants2.default.CHICK_RUN_DIRECTIONS[i]);
	      }
	
	      // Chicken plop animations
	      for (var i = 0; i < _constants2.default.CHICK_HATCH_POSITIONS.length; i++) {
	        this.createChickenPlopAnimation(_constants2.default.CHICK_HATCH_POSITIONS[i]);
	      }
	
	      // Corinne idle animation
	      var runFrameNames = this.anims.generateFrameNames(_constants2.default.ATLAS_KEY, {
	        start: 0, end: 299, zeroPad: 4,
	        prefix: "animations/corinne/", suffix: ".png"
	      });
	      this.anims.create({ key: "corinne-idle", frames: runFrameNames, frameRate: 10, repeat: -1 });
	    }
	  }, {
	    key: "createChickRunAnimation",
	    value: function createChickRunAnimation(direction) {
	      var runFrameNames = this.anims.generateFrameNames(_constants2.default.ATLAS_KEY, {
	        start: 1, end: 6, zeroPad: 4,
	        prefix: "animations/chicks/run/" + direction + "/", suffix: ".png"
	      });
	      var animationKey = "chick-run-" + direction;
	      this.anims.create({ key: animationKey, frames: runFrameNames, frameRate: 10, repeat: -1 });
	    }
	  }, {
	    key: "createChickenPlopAnimation",
	    value: function createChickenPlopAnimation(position) {
	      var runFrameNames = this.anims.generateFrameNames(_constants2.default.ATLAS_KEY, {
	        start: 1, end: 6, zeroPad: 4,
	        prefix: "animations/chicks/plop/" + position + "/", suffix: ".png"
	      });
	      var animationKey = "chick-plop-" + position;
	      this.anims.create({ key: animationKey, frames: runFrameNames, frameRate: 10 });
	    }
	  }]);
	
	  return Loader;
	}(Phaser.Scene);
	
	exports.default = Loader;

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _text = __webpack_require__(371);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Text = void 0;
	
	var MAIN_MENU = "main-menu";
	var PAUSE_MENU = "pause-menu";
	
	var Menu = function (_Phaser$Scene) {
	  _inherits(Menu, _Phaser$Scene);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, { key: "Menu" }));
	
	    _this.type = MAIN_MENU;;
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: "init",
	    value: function init(_ref) {
	      var type = _ref.type;
	
	      Text = (0, _text2.default)();
	
	      if (type === MAIN_MENU || type === PAUSE_MENU) {
	        this.type = type;
	      }
	
	      if (typeof this.type === "undefined" || this.type === null) {
	        this.type = MAIN_MENU;
	      }
	
	      if (this.type === PAUSE_MENU) {
	        this.scene.setVisible(false);
	      }
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      this.createBackground();
	
	      this.createText();
	
	      this.createButton();
	    }
	  }, {
	    key: "createBackground",
	    value: function createBackground() {
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      if (this.type === MAIN_MENU) {
	        this.add.image(0, 0, _constants2.default.ATLAS_KEY, "scene/sand.jpg").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
	        this.add.image(0, 0, _constants2.default.ATLAS_KEY, "scene/grass.png").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
	        this.add.image(0, 0, _constants2.default.ATLAS_KEY, "scene/fence.png").setOrigin(0, 0).setDisplaySize(gameWidth, gameHeight);
	      }
	
	      this.backdrop = this.add.image(0, 0, _constants2.default.ATLAS_KEY, "misc/bg_overlay.png").setOrigin(0, 0);
	      this.backdrop.setDisplaySize(gameWidth, gameHeight);
	
	      var cloud = this.add.image(0, 0, _constants2.default.ATLAS_KEY, "misc/background_cloud.png").setOrigin(0);
	      cloud.setDisplaySize(gameWidth, gameHeight);
	      // cloud.createBitmapMask();
	      // paint.setMask(cloud);
	    }
	  }, {
	    key: "createText",
	    value: function createText() {
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	
	      this.title = this.add.text(gameWidth / 2, 25, Text.menu.title, { fontFamily: "RabbitOnTheMoon", fontSize: 28, fontWeight: "normal", fill: "#FFFFFF", align: "center" }).setOrigin(0.5, 0).setPadding(15);
	      this.controlsText = this.add.text(gameWidth / 2, this.title.y + this.title.height, Text.menu.controlsDescription, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 18, fontWeight: "normal", fill: "#FFFFFF", align: "center" }).setOrigin(0.5, 0).setPadding({ bottom: 15 });
	
	      this.menuImage = this.add.image(gameWidth / 2, this.controlsText.y + this.controlsText.height, _constants2.default.ATLAS_KEY, "misc/menu_chicks.png").setOrigin(0.5, 0);
	    }
	  }, {
	    key: "createButton",
	    value: function createButton() {
	      var _this2 = this;
	
	      var CENTER = {
	        x: this.cameras.main.width / 2,
	        y: this.cameras.main.height / 2
	      };
	
	      var buttonImage = this.add.image(CENTER.x, this.menuImage.y + this.menuImage.height + 15, _constants2.default.ATLAS_KEY, "misc/button.png").setOrigin(0.5, 0);
	      var playIconWidth = this.scene.systems.game.textures.getFrame(_constants2.default.ATLAS_KEY, "misc/icon_play.png").realWidth;
	      var btnText = this.type === PAUSE_MENU ? Text.menu.resumeBtn : Text.menu.playBtn;
	      var startButtonText = this.add.text(CENTER.x + playIconWidth, buttonImage.y + buttonImage.height / 2, btnText, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 21, fill: "#ffffff" }).setOrigin(0.5).setPadding({ left: 15 });
	      var playIcon = this.add.image(startButtonText.x - startButtonText.width / 2, startButtonText.y, _constants2.default.ATLAS_KEY, "misc/icon_play.png").setOrigin(1, 0.5);
	
	      //  Handle the click or tap of the button using an input zone slightly
	      //  bigger than the text object.
	      this.playBtnZone = this.add.zone(buttonImage.x - buttonImage.width * buttonImage.originX - 5, buttonImage.y - buttonImage.height * buttonImage.originY - 5, buttonImage.width + 10, buttonImage.height + 10).setName("play-button").on("pointerover", function (e) {
	        _this2.input.mouse.target.style.cursor = "pointer";
	      }).on("pointerout", function (e) {
	        _this2.input.mouse.target.style.cursor = "";
	      });
	
	      this.setPlayBtnEvent();
	
	      if (this.type === MAIN_MENU) {
	        this.setInteractive();
	      }
	    }
	  }, {
	    key: "setPlayBtnEvent",
	    value: function setPlayBtnEvent() {
	      var _this3 = this;
	
	      this.playBtnZone.once("pointerup", function () {
	        _this3.input.mouse.target.style.cursor = "";
	
	        if (_this3.type === PAUSE_MENU) {
	          _this3.events.emit("resume-btn-clicked");
	          _this3.setPlayBtnEvent();
	        } else {
	          _this3.scene.start("Game");
	        }
	      });
	    }
	  }, {
	    key: "setInteractive",
	    value: function setInteractive(flag) {
	      if (flag !== false) {
	        if (this.playBtnZone) {
	          this.playBtnZone.setInteractive();
	        }
	      } else {
	        if (this.playBtnZone) {
	          this.playBtnZone.removeInteractive();
	        }
	      }
	
	      return this;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(flag) {
	      if (flag) {
	        this.setInteractive(flag !== false);
	      } else {
	        this.setInteractive(flag !== false);
	      }
	
	      this.scene.setVisible(flag);
	
	      return this;
	    }
	  }]);
	
	  return Menu;
	}(Phaser.Scene);
	
	exports.default = Menu;

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(25);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _constants = __webpack_require__(90);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 15/05/2018.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Scoreboard = function (_Phaser$Scene) {
	  _inherits(Scoreboard, _Phaser$Scene);
	
	  function Scoreboard() {
	    _classCallCheck(this, Scoreboard);
	
	    return _possibleConstructorReturn(this, (Scoreboard.__proto__ || Object.getPrototypeOf(Scoreboard)).call(this, {
	      key: "Scoreboard"
	    }));
	  }
	
	  _createClass(Scoreboard, [{
	    key: "init",
	    value: function init(_ref) {
	      var _this2 = this;
	
	      var gameScene = _ref.gameScene;
	
	      this.gameScene = gameScene;
	      this.gameScene.events.off("game-time-updated").on("game-time-updated", function (time) {
	        return _this2.setGameTime(time);
	      });
	    }
	  }, {
	    key: "create",
	    value: function create() {
	      var _this3 = this;
	
	      var gameWidth = this.sys.game.config.width;
	      var gameHeight = this.sys.game.config.height;
	      var spacing = 15;
	
	      this.helpImageBtn = this.add.image(spacing, spacing, _constants2.default.ATLAS_KEY, "misc/image_info.png").setOrigin(0, 0);
	      this.helpBtnZone = this.add.zone(this.helpImageBtn.x - this.helpImageBtn.width * this.helpImageBtn.originX - 5, this.helpImageBtn.y - this.helpImageBtn.height * this.helpImageBtn.originY - 5, this.helpImageBtn.width + 10, this.helpImageBtn.height + 10).setName("help-button").setInteractive().on("pointerup", function () {
	        _this3.input.mouse.target.style.cursor = "";
	        _this3.gameScene.togglePause();
	        _this3.showHelpScreen();
	      }).on("pointerover", function (e) {
	        _this3.input.mouse.target.style.cursor = "pointer";
	      }).on("pointerout", function (e) {
	        _this3.input.mouse.target.style.cursor = "";
	      });
	
	      this.scoreLabel = this.add.text(gameWidth - spacing, spacing - 10, "00:00", { fontFamily: "RabbitOnTheMoon", fontSize: 42, fontWeight: "normal", fill: "#89ae37" }).setOrigin(1, 0);
	
	      if (this.gameScene.debug) {
	        this._debugText = this.add.text(100, 20).setDepth(999);
	        this._debugText.setShadow(1, 1, "#000000", true, false);
	      }
	    }
	  }, {
	    key: "setHelpButtonInteractive",
	    value: function setHelpButtonInteractive(flag) {
	      if (flag !== false) {
	        if (this.helpBtnZone) {
	          this.helpBtnZone.setInteractive();
	        }
	      } else {
	        if (this.helpBtnZone) {
	          this.helpBtnZone.removeInteractive();
	        }
	      }
	    }
	  }, {
	    key: "setGameTime",
	    value: function setGameTime(time) {
	      this.scoreLabel.setText(_utils2.default.formatTime(time, "mm:ss"));
	    }
	  }, {
	    key: "showHelpScreen",
	    value: function showHelpScreen() {
	      this.helpBtnZone.removeInteractive();
	
	      var menuScene = this.scene.get("Menu");
	      menuScene.setVisible(true);
	      menuScene.events.once("resume-btn-clicked", function () {
	        this.helpBtnZone.setInteractive();
	        menuScene.setInteractive(false).scene.setVisible(false);
	        this.gameScene.togglePause();
	      }, this);
	    }
	  }]);
	
	  return Scoreboard;
	}(Phaser.Scene);
	
	exports.default = Scoreboard;

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by jv on 10/03/2017.
	 */
	
	if (true) {
	  var gtag = function gtag() {
	    dataLayer.push(arguments);
	  };
	
	  window.dataLayer = window.dataLayer || [];
	
	  gtag('js', new Date());
	
	  gtag('config', 'UA-61834383-2');
	} else {
	  console.log("development Google Analytics disabled");
	}

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(25);
	var LanguageManager = __webpack_require__(38);
	var DialogTemplate = __webpack_require__(374);
	
	var dialog = {};
	
	(function (Dialog) {
	  Dialog.showMessageDialog = function (options) {
	    var messageDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        messageDialog.destroy();
	
	        if (utils.isFunction(options.onConfirm)) {
	          options.onConfirm();
	        }
	      },
	      onCancel: function onCancel() {
	        messageDialog.destroy();
	      }
	    });
	
	    messageDialog.show();
	
	    return messageDialog;
	  };
	
	  Dialog.showOkCancelDialog = function (options) {
	    var okCancelDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
	      cancelText: LanguageManager.getValueForKey("modal.buttons.cancel"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onOk)) {
	          options.onOk();
	        }
	      },
	      onCancel: function onCancel() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onCancel)) {
	          options.onCancel();
	        }
	      }
	    });
	
	    okCancelDialog.show();
	
	    return okCancelDialog;
	  };
	
	  Dialog.showYesNoDialog = function (options) {
	    var yesNoDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.yes"),
	      cancelText: LanguageManager.getValueForKey("modal.buttons.no"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onYes)) {
	          options.onYes();
	        }
	      },
	      onCancel: function onCancel() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onNo)) {
	          options.onNo();
	        }
	      }
	    });
	
	    yesNoDialog.show();
	
	    return yesNoDialog;
	  };
	})(dialog);
	
	module.exports = dialog;

/***/ })

});


// WEBPACK FOOTER //
// js/commons.ba3423db602384ddd7dd.js